const checkNoCustomer = () => $('section[data-section-type="collection"]')?.hasClass('no-customer');

$(document).on('click','[data-action="close-filter-sidebar-custom"]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ( $('.template-collection .boost-pfs-filter-left-col-custom').hasClass('open-filter')){
        $('.CollectionMain').removeClass('has-filter');
        $('.template-collection .boost-pfs-filter-left-col-custom').removeClass('open-filter');
        $('[data-category]').addClass('open-category');
    }else{
        $('.CollectionMain').addClass('has-filter');
        $('.template-collection .boost-pfs-filter-left-col-custom').addClass('open-filter');
    }
});

$(document).on('click','.CollectionToolbar__Item[aria-controls="collection-sort-popover"], .CollectionToolbar__Item[aria-controls="collection-sort-popover-1"]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (checkNoCustomer() && !authenticationKeyStatus) {
        showDialogLogin();
        return;
    }
});

$(document).on('click',
    '.CollectionToolbar__Group button.boost-pfs-filter-button-custom', function (e) {
    if (checkNoCustomer() && !authenticationKeyStatus) {
        e.preventDefault();
        e.stopPropagation();
        showDialogLogin();
        return;
    }
});

$(document).on('click','.close-search-collection', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.boost-pfs-filter-button-custom').attr("aria-expanded", false);
    $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').removeClass('is-active-custom');
    $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').addClass('toggled');

    $('.CollectionMain').addClass('has-filter');
    $('.template-collection .boost-pfs-filter-left-col-custom').addClass('open-filter');
    $(".over-lay-filter-product").css({"visibility":"hidden","opacity":"0"});
});

$(document).on('click','.boost-pfs-filter-option-title-custom .boost-pfs-filter-button-custom.boost-pfs-filter-option-title-heading-custom', function (e) {
    e.preventDefault();
    // e.stopPropagation();
    if ( $(this).parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').hasClass('toggled')){
        $('.boost-pfs-filter-button-custom').attr("aria-expanded", false);
        $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').addClass('boost-pfs-filter-option-collapsed-custom');
        $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').removeClass('is-active-custom');
        $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').addClass('toggled');
        $(this).attr("aria-expanded", true);
        $(this).parents('.boost-pfs-filter-option-custom').addClass('is-active-custom');
        $(this).parents('.boost-pfs-filter-option-custom').removeClass('boost-pfs-filter-option-collapsed-custom');
        $(this).parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').removeClass('toggled');
        if (window.innerWidth > 640) {
            $(".over-lay-filter-product").css({"visibility": "visible", "opacity": "0.4"});
        }
    }else{
        $(".over-lay-filter-product").css({"visibility":"hidden","opacity":"0"});
        $(this).attr("aria-expanded", false);
        $(this).parents('.boost-pfs-filter-option-custom').removeClass('is-active-custom');
        $(this).parents('.boost-pfs-filter-option-custom').addClass('boost-pfs-filter-option-collapsed-custom');
        $(this).parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').addClass('toggled');
    }
});

// if (window.innerWidth > 1140) {
//     $(document).on('mouseenter', '.boost-pfs-filter-option-title-custom .boost-pfs-filter-button-custom.boost-pfs-filter-option-title-heading-custom', function (e) {
//         e.preventDefault();
//         if ($(this).parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').hasClass('toggled')) {
//             $('.boost-pfs-filter-button-custom').attr("aria-expanded", false);
//             $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').addClass('boost-pfs-filter-option-collapsed-custom');
//             $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').removeClass('is-active-custom');
//             $('.boost-pfs-filter-option-title-heading-custom').parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').addClass('toggled');
//             $(this).attr("aria-expanded", true);
//             $(this).parents('.boost-pfs-filter-option-custom').addClass('is-active-custom');
//             $(this).parents('.boost-pfs-filter-option-custom').removeClass('boost-pfs-filter-option-collapsed-custom');
//             $(this).parents('.boost-pfs-filter-option-custom').find('.boost-pfs-filter-option-content-custom').removeClass('toggled');
//             $(".over-lay-filter-product").css({"visibility": "visible", "opacity": "0.4"});
//         }
//     });
// }
$(document).on('click','.category-filter-list', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const thisCategory = $(this).attr('data-category');
    if (!thisCategory) return;
    $(`[data-category=${thisCategory}]`).toggleClass('open-category');
    $(".over-lay-filter-product").css({"visibility":"hidden","opacity":"0"});
});

$(document).on('click','.boost-pfs-filter-close-custom, .boost-pfs-filter-show-result-custom', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ( $(this).parents('.boost-pfs-filter-tree-custom').hasClass('boost-pfs-filter-tree-mobile-open-custom')){
        $(this).parents('.boost-pfs-filter-tree-custom').removeClass('boost-pfs-filter-tree-mobile-open-custom');
    }
});

$(document).on('click','[data-action="open-drawer-custom"]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // if (checkNoCustomer() && !authenticationKeyStatus) {
    //     showDialogLogin();
    //     return;
    // }

    $('.boost-pfs-filter-tree-custom').addClass('boost-pfs-filter-tree-mobile-open-custom');
});

const displayCondition = {
    all: "all",
    logged: "logged",
};
const displayPage = {
    all: "all",
    pageSearch: "page_search",
    pageCollection: "page_collection",
};
const sortList = [
    {
        sort_field: 'shopify_created_at',
        sort_type: 'desc',
        text: '新着順',
        display_condition: displayCondition.all,
        display_page: displayPage.all,
        default: true,
        default_page: displayPage.all,
    },
    {
        sort_field: 'product_id',
        sort_type: 'asc',
        text: '品番（昇順）',
        display_condition: displayCondition.all,
        display_page: displayPage.all,
        default: false,
    },
    {
        sort_field: 'product_id',
        sort_type: 'desc',
        text: '品番（降順）',
        display_condition: displayCondition.all,
        display_page: displayPage.all,
        default: false,
    },
    {
        sort_field: 'price_by_company',
        sort_type: 'asc',
        text: '価格（昇順）',
        display_condition: displayCondition.logged,
        display_page: displayPage.all,
        default: false,
    },
    {
        sort_field: 'price_by_company',
        sort_type: 'desc',
        text: '価格（降順）',
        display_condition: displayCondition.logged,
        display_page: displayPage.all,
        default: false,
    }
];
const filterType = {
    checkbox: "checkbox",
    rangeBar: "range_bar",
    singleSelect: "single_select",
};
const filterAction = {
    add: "add",
    delete : "delete",
    deleteAll : "delete_all",
    change: "change",
    changeToDefault : "change_to_default",
};

const reverseList = {
    "f_textile_class": {
        type: filterType.checkbox,
    },
    "organization_taxonomy": {
        type: filterType.checkbox,
    },
    "f_pattern_plain": {
        type: filterType.singleSelect,
    },
    "colors": {
        type: filterType.checkbox,
    },
    "f_formulation": {
        type: filterType.checkbox,
    },
    "f_sqm_min": {
        type: filterType.rangeBar,
        position: "min",
    },
    "f_sqm_max": {
        type: filterType.rangeBar,
        position: "max",
    },
    "price_by_company_min": {
        type: filterType.rangeBar,
        position: "min",
    },
    "price_by_company_max": {
        type: filterType.rangeBar,
        position: "max",
    },
    "product_stock": {
        type: filterType.checkbox,
    },
    "sec_cd": {
        type: filterType.checkbox,
    },
    "shopify_collection": {
        type: filterType.checkbox,
    },
    "f_function_cd": {
        type: filterType.checkbox,
    },
    "f_sustainability1_cd": {
        type: filterType.checkbox,
    },
    "f_sustainability2_cd": {
        type: filterType.checkbox,
    },
    "f_sustainability3_cd": {
        type: filterType.checkbox,
    },
    "f_sustainability4_cd": {
        type: filterType.checkbox,
    },
    "f_sustainability5_cd": {
        type: filterType.checkbox,
    },
    "f_certification1_cd": {
        type: filterType.checkbox,
    },
    "f_certification2_cd": {
        type: filterType.checkbox,
    },
    "f_certification3_cd": {
        type: filterType.checkbox,
    },
    "f_certification4_cd": {
        type: filterType.checkbox,
    },
    "f_certification5_cd": {
        type: filterType.checkbox,
    },
    "f_certification_other_cd": {
        type: filterType.checkbox,
    },
    // "quality_report": {
    //     type: filterType.checkbox,
    // },
    "digitalfabric_release": {
        type: filterType.checkbox,
    },
    // "digitalprintfb": {
    //     type: filterType.checkbox,
    // },
    "f_hand_feeling_cd": {
        type: filterType.checkbox,
    },
    "f_feature_cd": {
        type: filterType.checkbox,
    },
    // "f_clothing_item_cd": {
    //     type: filterType.checkbox,
    // },
    "f_width_valid_min": {
        type: filterType.rangeBar,
        position: "min",
    },
    "f_width_valid_max": {
        type: filterType.rangeBar,
        position: "max",
    },
    "dye_method_name": {
        type: filterType.checkbox,
    },
    // "f_finishing_category_cd": {
    //     type: filterType.checkbox,
    // },
    "f_dye_origin_cd": {
        type: filterType.checkbox,
    },
    "construction_name_name": {
        type: filterType.checkbox,
    },
    "is_composition_absolute": {
        type: filterType.checkbox,
    },
  };

const filterList = {
    "f_textile_class": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: fabricType.text,
        icon_class: "boost-pfs-filter-option-fabric-type",
    },
    "organization_taxonomy": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: construction,
        icon_class: "boost-pfs-filter-option-construction",
    },
    "f_pattern_plain": {
        type: filterType.singleSelect,
        display_condition: displayCondition.all,
        be_return: true,
        text: fabricPattern,
        icon_class: "boost-pfs-filter-option-pattern",
    },
    "colors": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: color,
        icon_class: "boost-pfs-filter-option-color",
    },
    "f_formulation": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: composition,
        icon_class: "boost-pfs-filter-option-composition",
    },
    "f_sqm": {
        type: filterType.rangeBar,
        display_condition: displayCondition.all,
        be_return: true,
        text: weight,
        icon_class: "boost-pfs-filter-option-weight-g-x2f-㎡",
    },
    "price_by_company": {
        type: filterType.rangeBar,
        display_condition: displayCondition.all,
        be_return: true,
        text: price,
        icon_class: "boost-pfs-filter-option-price",
    },
    "product_stock": {
        type: filterType.checkbox,
        display_condition: displayCondition.logged,
        be_return: false,
        text: stockAvailability.text,
        icon_class: "boost-pfs-filter-option-stock",
        data: {
            0: {
                key: "product_stock",
                value: stockAvailability.in_stock,
            },
        },
    },
    "sec_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: sec,
        icon_class: "boost-pfs-filter-option-section",
    },
    "shopify_collection": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: fabricCollection,
        icon_class: "boost-pfs-filter-option-collection",
    },
    "f_function_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: "FUNCTIONAL/PLUS FUNCTION™",
        icon_class: "boost-pfs-filter-option-plus-function®",
    },
    "f_sustainability_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: false, // thuc te la true, set false de de xu ly
        text: sustainableEcoarch,
        icon_class: "boost-pfs-filter-option-ecoarch®",
        dataKey: [
            "f_sustainability1_cd",
            "f_sustainability2_cd",
            "f_sustainability3_cd",
            "f_sustainability4_cd",
            "f_sustainability5_cd"
        ]
    },
    "f_certification_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: false, // thuc te la true, set false de de xu ly
        text: certification,
        icon_class: "boost-pfs-filter-option-サステナブル根拠",
        dataKey: [
            "f_certification1_cd",
            "f_certification2_cd",
            "f_certification3_cd",
            "f_certification4_cd",
            "f_certification5_cd",
            "f_certification_other_cd"
        ]
    },
    // "quality_report": {
    //     type: filterType.checkbox,
    //     display_condition: displayCondition.logged,
    //     be_return: false,
    //     text: "品質データ",
    //     icon_class: "boost-pfs-filter-option-品質データ",
    //     data: {
    //         0 : {
    //             key: "quality_report",
    //             value: "データ有り",
    //         },
    //     },
    // },
    "digitalfabric_release": {
        type: filterType.checkbox,
        display_condition: displayCondition.logged,
        be_return: false,
        text: digitalFabric.text,
        icon_class: "boost-pfs-filter-option-digital-fabric®",
        data: {
            0: {
                key: "digitalfabric_release",
                value: digitalFabric.targeted,
            },
        },
    },
    // "digitalprintfb": {
    //     type: filterType.checkbox,
    //     display_condition: displayCondition.logged,
    //     be_return: false,
    //     text: "Print On Demand対応",
    //     icon_class: "boost-pfs-filter-option-print-on-demand",
    //     data: {
    //         0: {
    //             key: "digitalprintfb",
    //             value: "対象あり",
    //         },
    //     },
    // },
    "f_hand_feeling_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: feeling,
        icon_class: "boost-pfs-filter-option-feeling",
    },
    "f_feature_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: appearance,
        icon_class: "boost-pfs-filter-option-appearance",
    },
    // "f_clothing_item_cd": {
    //     type: filterType.checkbox,
    //     display_condition: displayCondition.all,
    //     be_return: true,
    //     text: "用途（アイテム）",
    //     icon_class: "boost-pfs-filter-option-item",
    // },
    "f_width_valid": {
        type: filterType.rangeBar,
        display_condition: displayCondition.all,
        be_return: true,
        text: width,
        icon_class: "boost-pfs-filter-option-width-cm",
    },
    "dye_method_name": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: howToDye,
        icon_class: "boost-pfs-filter-option-染色方法",
    },
    // "f_finishing_category_cd": {
    //     type: filterType.checkbox,
    //     display_condition: displayCondition.logged,
    //     be_return: true,
    //     text: "加工内容",
    //     icon_class: "boost-pfs-filter-option-加工内容",
    // },
    "f_dye_origin_cd": {
        type: filterType.checkbox,
        display_condition: displayCondition.all,
        be_return: true,
        text: madeIn,
        icon_class: "boost-pfs-filter-option-原産国",
    },
};

const filterListNo = [
    "f_textile_class",
    "organization_taxonomy",
    "f_formulation",
    "f_pattern_plain",
    "colors",
    "f_function_cd",
    "f_sustainability_cd",
    "f_certification_cd",
    "shopify_collection",
    "f_hand_feeling_cd",
    "f_feature_cd",
    // "f_clothing_item_cd",
    "f_sqm",
    "f_width_valid",
    "f_dye_origin_cd",
    "dye_method_name",
    // "f_finishing_category_cd",
    "price_by_company",
    // "product_stock",
    // "quality_report",
    // "digitalfabric_release",
    // "digitalprintfb",
    "sec_cd",
];
const PER_PAGE = 48;
const plusFunctionImgLink = "https://cdn.shopify.com/s/files/1/0568/1348/6170/files/PLUS_FUNCTION.png?v=1667443800";
const ecoarchImgLink = "https://cdn.shopify.com/s/files/1/0667/9786/3202/files/ECOARCH_x30.png?v=1687331030";
const imageDefaultLink = {
    "stylem-dev.myshopify.com": "https://stylem-dev.myshopify.com/cdn/shop/files/boost-pfs-no-image.gif?v=1686717385",
    "dev-stylemdigitalpf.myshopify.com": "https://dev-stylemdigitalpf.myshopify.com/cdn/shop/files/boost-pfs-no-image.gif?v=1686717440",
    "jp.stylemfabrics.com": "https://jp.stylemfabrics.com/cdn/shop/files/boost-pfs-no-image.gif?v=1686717537",
    "dev-stylemdigitalpf-northamerica.myshopify.com": "https://dev-stylemdigitalpf-northamerica.myshopify.com/cdn/shop/files/boost-pfs-no-image.gif?v=1686717488",
    "us.stylemfabrics.com": "https://us.stylemfabrics.com/cdn/shop/files/boost-pfs-no-image.gif?v=1686717587"
};
const filterListNoGroup = new Array();
filterListNoGroup[0] = new Array("organization_taxonomy","f_formulation", "f_sqm", "f_width_valid", "f_dye_origin_cd","dye_method_name" );
filterListNoGroup[1] = new Array("f_pattern_plain","colors");
filterListNoGroup[2] = new Array("f_hand_feeling_cd","f_feature_cd", "f_function_cd","f_sustainability_cd","f_certification_cd","shopify_collection");
filterListNoGroup[3] = new Array("sec_cd");
const colorList = {
    'White / Off white': '#FFFFFF',
    'Pink / Lavender': '#F277C6',
    'Sax blue': '#69B3E7',
    'Green': '#397E60',
    'Silver': '#E5E5E5',
    'Beige': '#F4F1E1',
    'Wine / Purple': '#982BA4',
    'Blue': '#0057B7',
    'Khaki': '#6D774A',
    'Gray': '#BBBBBB',
    'Orange / Yellow': '#F7E581',
    'Red': '#BE132D',
    'Navy': '#0A1B52',
    'Mocha / Camel': '#B4A77D',
    'Charcoal': '#565656',
    'Gold': '#F1C440',
    'Indigo' : '#002855',
    'Brown': '#522A0B',
    'Black': '#000000',
};
openFilterLoading();
document.addEventListener("DOMContentLoaded", () => {
    renderSortOptions();
    let filterAtrribute = [];
    let isLogin = customerIdCheck ? true : false;
    let getAttributeParams = {}
    if (isLogin) {
        loginCompanyCode = localStorage.getItem('current_company') || '';
        loginCompanyType = localStorage.getItem('current_company_type') || '';
        if (loginCompanyCode == "") {
            loginCompanyCode = companyRepresentativeGlobal;
        }
        if (loginCompanyType == ""){
            loginCompanyType = 'null';
        }
        getAttributeParams['company_code'] = loginCompanyCode;
        getAttributeParams['company_type'] = loginCompanyType;
    }
    else {
        $('#collection-filter.CollectionMain.Custom-dev')?.addClass('has-filter');
        $('#collection-filter.CollectionMain.Custom-dev .boost-pfs-filter-left-col-custom')?.addClass('open-filter');
      if (authenticationKeyStatus) {
        getAttributeParams['company_code'] = companyRepresentativeGlobal;
        getAttributeParams['company_type'] = 'null';
      }
    }
    $.ajaxSetup({async: false});
    $.ajax({
        url: "/apps/dev-1/filter_products/attributes",
        method: 'GET',
        dataType: 'json',
        data: getAttributeParams,
        success: function (response) {
            filterAtrribute = response;
        }
    });
    const groupIcon =
        `<span class="group-icon">
        <svg class="icon-plus" role="presentation" viewBox="0 0 16 16">
            <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <path d="M8,1 L8,15"></path>
            <path d="M1,8 L15,8"></path>
            </g>
        </svg>
        <svg class="icon-minus" role="presentation" viewBox="0 0 16 2">
            <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
        </svg>
    </span>`;
    $(".boost-pfs-filter-options-wrapper-custom").append(`<div class="selected-item-filter-mobile"></div>`);
    filterListNoGroup.forEach(function(list, index) {
        if (index == 0) {
            $(".boost-pfs-filter-options-wrapper-custom").append(`<h4 class="category-filter-list open-category" data-category="${index}"><span class="category-name">Fabric Features</span>${groupIcon}</h4>`);
        }else if(index == 1){
            $(".boost-pfs-filter-options-wrapper-custom").append(`<h4 class="category-filter-list margin-btn-custom open-category" data-category="${index}"><span class="category-name">Visual</span>${groupIcon}</h4>`);
        }else if(index == 2){
            $(".boost-pfs-filter-options-wrapper-custom").append(`<h4 class="category-filter-list margin-btn-custom open-category" data-category="${index}"><span class="category-name">Speciality</span>${groupIcon}</h4>`);
        }else {
            $(".boost-pfs-filter-options-wrapper-custom").append(`<h4 class="category-filter-list margin-btn-custom open-category" data-category="${index}"><span class="category-name">Other</span>${groupIcon}</h4>`);
        }
        list.forEach(function(key) {
            let sliderInitObject = {}
            if ((filterAtrribute[key] || !filterList[key].be_return)
                && (filterList[key].display_condition == displayCondition.all || (filterList[key].display_condition == displayCondition.logged && (customerIdCheck || authenticationKeyStatus)))
            ) {
                let hasDataList = true;
                let subFilterItem = ``;
                let categoryKeys = filterAtrribute[key] ? Object.keys(filterAtrribute[key]) : null;
                if (key == "f_certification_cd" || key == "f_sustainability_cd") {
                    let hasDataItem = false;
                    let subFilterItemChildren = ``;
                    filterList[key].dataKey.forEach(function(itemKey) {
                        if (filterAtrribute[itemKey] && Object.keys(filterAtrribute[itemKey]).length > 0) {
                            categoryKeys = Object.keys(filterAtrribute[itemKey]);
                            hasDataItem = true;
                            categoryKeys.forEach(function(subKey) {
                              filterAtrribute[itemKey][subKey].forEach(function(itemSubKey) {
                                subFilterItemChildren = subFilterItemChildren + `
                                <li class="boost-pfs-filter-option-item-custom boost-pfs-filter-option-label-custom item-value-custom ${filterList[key].type}" data-id="${itemKey+itemSubKey.attribute}" data-key="${itemKey}" data-value="${itemSubKey.attribute}" data-value-url="${itemSubKey.value_url}" data-name="${itemSubKey.name}" data-type="${filterList[key].type}">
                                  <button role="checkbox" class="boost-pfs-filter-button-custom">
                                    <span class="boost-pfs-check-box-custom" role="checkbox" tabindex="0" aria-labelledby="${itemSubKey.name}"></span>
                                    <span class="boost-pfs-filter-option-value-custom">${itemSubKey.name}</span>
                                    <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                  </button>
                                </li>`;
                              })
                            })
                        }
                    });

                    if(hasDataItem) {
                        let subClassItem = filterList[key].type == filterType.checkbox ? 'multiple-list' : 'single-list';
                        subFilterItem = `
                            <div class="boost-pfs-filter-option-content-inner-custom has-scrollbar">
                                <ul class="boost-pfs-filter-option-item-list-custom boost-pfs-filter-option-item-list-${subClassItem}-custom ${key}">
                                    ${subFilterItemChildren}
                                </ul>
                            </div>`;
                    } else {
                        hasDataList = false;
                    }
                } else if(key === "organization_taxonomy") {
                    let subClassItem = 'multiple-list';
                    let categoryFilterItem = `<div class="boost-pfs-filter-option-content-inner-custom has-scrollbar">`;
                    if (categoryKeys) {
                        categoryKeys.forEach(function(subKey, index) {
                            categoryFilterItem = categoryFilterItem + `<div class="category__wrap category-index-${index + 1} category-group-lever-1 category-group-${subKey} toggled" data-category="${subKey}">
                                      <div class="form-group category-name-organization-taxonomy">
                                          <div class="boost-pfs-filter-option-item-custom-top boost-pfs-filter-option-label-custom item-value-custom checkbox checkbox-lever-1" data-id="f_textile_class${subKey}" data-name="${subKey}" data-key="f_textile_class" data-value="${filterAtrribute['f_textile_class']['no_category'][index]['attribute']}" data-value-url="${subKey}" data-type="checkbox">
                                            <button role="checkbox" class="boost-pfs-filter-button-custom">
                                              <span class="boost-pfs-check-box-custom-top" role="checkbox" tabindex="0" aria-labelledby="${subKey}"></span>
                                              <span class="boost-pfs-filter-option-value-custom">${subKey}</span>
                                              <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                            </button>
                                          </div>
                                          <button class="select-arrow select-arrow-${subKey} hidden" data-hidden="category-group-lever-2-${subKey}" data-action="${subKey}"><svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">
                                              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
                                            </svg></button>
                                          <button class="select-top select-top-${subKey}" data-hidden="category-group-lever-2-${subKey}" data-action="${subKey}">
                                           <svg class="Icon arrow-top" role="presentation" viewBox="0 0 21 11">
                                                  <polyline fill="none" stroke="currentColor" points="20.5 10.5 10.5 0.5 0.5 10.5" stroke-width="1.25"></polyline>
                                                </svg>
                                            </button>
                                      </div>`;
                            let categoryKeysLv2 = filterAtrribute[key][subKey] ? Object.keys(filterAtrribute[key][subKey]) : null;
                            if (categoryKeysLv2) {
                                categoryKeysLv2.forEach(function (subKey2, index2) {
                                    categoryFilterItem = categoryFilterItem + `
                                  <div class="category__wrap category-index-2-${index2 + 1} category-group-${subKey2} category-group-lever-2 category-group-lever-2-${subKey} toggled" data-category="${subKey2}">
                                  <div class="form-group subcategory-name">
                                      <div class="boost-pfs-filter-option-item-custom-top boost-pfs-filter-option-label-custom checkbox-lever-2 item-value-custom checkbox" data-id="${key + subKey2}" data-name="${subKey2}" data-key="${key}" data-value="${filterAtrribute[key][subKey][subKey2][0]['attribute_category']}" data-value-url="${filterAtrribute[key][subKey][subKey2][0]['attribute_category']}" data-type="checkbox">
                                        <button role="checkbox" class="boost-pfs-filter-button-custom">
                                          <span class="boost-pfs-check-box-custom-top" role="checkbox" tabindex="0" aria-labelledby="${subKey2}"></span>
                                          <span class="boost-pfs-filter-option-value-custom">${subKey2}</span>
                                          <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                        </button>
                                      </div>
                                      <button class="select-arrow-lever-3 select-arrow-lever-3-${subKey2}" data-hidden="category-group-lever-3-${subKey2}" data-action="${subKey2}"><svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">
                                              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
                                            </svg></button>
                                     <button class="select-top-lever-3 hidden select-top-lever-3-${subKey2}" data-hidden="category-group-lever-3-${subKey2}" data-action="${subKey2}">
                                           <svg class="Icon arrow-top" role="presentation" viewBox="0 0 21 11">
                                                  <polyline fill="none" stroke="currentColor" points="20.5 10.5 10.5 0.5 0.5 10.5" stroke-width="1.25"></polyline>
                                                </svg>
                                            </button>
                                  </div>
                                  <ul class="boost-pfs-filter-option-item-list-custom boost-pfs-filter-option-item-list-${subClassItem}-custom ${key}-custom category-group-lever-3-${subKey2} hidden">`;
                                    filterAtrribute[key][subKey][subKey2].forEach(function (item) {
                                        categoryFilterItem = categoryFilterItem + `
                                      <li class="boost-pfs-filter-option-item-custom boost-pfs-filter-option-label-custom item-value-custom ${filterList[key].type}" data-id="${item.type + item.attribute}" data-key="${item.type}" data-value="${item.attribute}" data-value-url="${item.value_url}" data-name="${item.name?.replace('<!--', '').replace('-->', '')}" data-type="${filterList[key].type}">
                                      <button role="checkbox" class="boost-pfs-filter-button-custom">
                                          <span class="boost-pfs-check-box-custom" role="checkbox" tabindex="0" aria-labelledby="${item.name}"></span>
                                          <span class="boost-pfs-filter-option-value-custom">${item.name?.replace('<!--', '').replace('-->', '').replace('（', '<span class="custom-font-size">（').replace('）', '）</span>')}</span>
                                          <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                      </button>
                                      </li>
                                  `;
                                    })
                                    categoryFilterItem = categoryFilterItem + `</ul></div>`;
                                })

                            }
                            categoryFilterItem = categoryFilterItem + `</div>`;
                        })
                    }
                    subFilterItem = categoryFilterItem + `</div></div>`;
                } else if(filterList[key].be_return && (filterList[key].type == filterType.checkbox || filterList[key].type == filterType.singleSelect)) {
                    let subClassItem = filterList[key].type == filterType.checkbox ? 'multiple-list' : 'single-list';
                    let categoryFilterItem = ``;
                    if (categoryKeys) {
                      const countCategoryEachGroup = Math.round(categoryKeys.length / 3);
                      let currentGroupNumber = 1;
                      let initStartGroup = false;
                      let initEndGroup = false;
                      categoryKeys.forEach(function(subKey, index) {
                        if (filterAtrribute[key][subKey].length > 0) {
                          if (index >= (countCategoryEachGroup * currentGroupNumber) && (countCategoryEachGroup * currentGroupNumber) >= 1 && currentGroupNumber < 3) {
                            currentGroupNumber++;
                            initStartGroup = true;
                            initEndGroup = true;
                          }
                          if (initEndGroup) {
                            categoryFilterItem = categoryFilterItem + `</div>`
                            initEndGroup = false;
                          }
                          if (initStartGroup) {
                            categoryFilterItem = categoryFilterItem + `<div class="category__group category-group-${currentGroupNumber}">`
                            initStartGroup = false;
                          }
                          categoryFilterItem = categoryFilterItem + `
                          <div class="category__wrap category-index-${index + 1} category-group-${currentGroupNumber} toggled" data-category="${subKey}">
                          <p class="category-name ${subKey === "no_category" || key === "f_dye_origin_cd" ? "hidden" : ""}">
                            ${subKey}
                            <svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">
                              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
                            </svg>
                          </p>
                          <ul class="boost-pfs-filter-option-item-list-custom boost-pfs-filter-option-item-list-${subClassItem}-custom ${key}">`;
                          filterAtrribute[key][subKey].forEach(function(item) {
                              var isMobile = Math.min(window.screen.width, window.screen.height) < 768;
                              if (key == "colors" && !isMobile) {
                                  categoryFilterItem = categoryFilterItem + `
                                      <li class="boost-pfs-filter-option-label-custom-color boost-pfs-filter-option-item-custom boost-pfs-filter-option-label-custom item-value-custom ${filterList[key].type}" data-id="${key+item.attribute}" data-key="${key}" data-value="${item.attribute}" data-value-url="${item.value_url}" data-name="${item.name?.replace('<!--','').replace('-->','')}" data-type="${filterList[key].type}">
                                          <button role="checkbox" class="boost-pfs-filter-button-custom">
                                                  <span class="boost-pfs-check-box-custom" role="checkbox" tabindex="0" aria-labelledby="${item.name}"></span>
                                                  <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                          </button>

                                          <div class="div-color">
                                              <div class="div-background-color" style="background-color: ${colorList[item.attribute]}">
                                                  <svg class="icon-checked-custom" role="presentation" viewBox="0 0 24 24">
                                                      <polygon fill="currentColor" points="9,20 2,13 5,10 9,14 19,4 22,7 "></polygon>
                                                  </svg>
                                              </div>
                                              <span class="boost-pfs-filter-option-value-custom-color">${item.name?.replace('<!--', '').replace('-->', '')}</span>
                                          </div>
                                      </li>
                                  `;
                              } else if (key == "colors" && isMobile){
                                  categoryFilterItem = categoryFilterItem + `
                                      <li class="boost-pfs-filter-option-item-custom boost-pfs-filter-option-label-custom item-value-custom ${filterList[key].type}" data-id="${key+item.attribute}" data-key="${key}" data-value="${item.attribute}" data-value-url="${item.value_url}" data-name="${item.name?.replace('<!--','').replace('-->','')}" data-type="${filterList[key].type}">
                                      <button role="checkbox" class="boost-pfs-filter-button-custom">
                                          <span class="boost-pfs-check-box-custom" role="checkbox" tabindex="0" aria-labelledby="${item.name}"></span>
                                          <span class="div-background-color-mb" style="background-color: ${colorList[item.attribute]}"></span>
                                          <span class="boost-pfs-filter-option-value-custom">${item.name?.replace('<!--','').replace('-->','')}</span>
                                          <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                      </button>
                                      </li>
                                  `;
                              } else {
                                  categoryFilterItem = categoryFilterItem + `
                                      <li class="boost-pfs-filter-option-item-custom boost-pfs-filter-option-label-custom item-value-custom ${filterList[key].type}" data-id="${key+item.attribute}" data-key="${key}" data-value="${item.attribute}" data-value-url="${item.value_url}" data-name="${item.name?.replace('<!--','').replace('-->','')}" data-type="${filterList[key].type}" data-composition-absolute="${item.is_composition_absolute}">
                                      <button role="checkbox" class="boost-pfs-filter-button-custom">
                                          <span class="boost-pfs-check-box-custom" role="checkbox" tabindex="0" aria-labelledby="${item.name}"></span>
                                          <span class="boost-pfs-filter-option-value-custom">${item.name?.replace('<!--','').replace('-->','').replace('(','<span class="custom-font-size">(').replace(')',')</span>')}</span>
                                          <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                      </button>
                                      </li>
                                  `;
                              }
                          });
                          categoryFilterItem = categoryFilterItem + `</ul></div>`;
                        }
                      })
                      categoryFilterItem = `<div class="boost-pfs-filter-option-content-inner-custom has-scrollbar">` + `<div class="category__group category-group-1">` + categoryFilterItem + `</div>`
                    } else {
                      categoryFilterItem = `<div class="boost-pfs-filter-option-content-inner-custom has-scrollbar">`;
                    }
                    subFilterItem = categoryFilterItem + `</div>`;
                } else if (filterList[key].type == filterType.rangeBar) {
                    let minAttribute = filterAtrribute[key]['no_category'].find(item => item.attribute == 'min');
                    let maxAttribute = filterAtrribute[key]['no_category'].find(item => item.attribute == 'max');
                    let btnSqm = '';
                    if (minAttribute && maxAttribute && (minAttribute.value || minAttribute.value == 0)
                        && (maxAttribute.value || maxAttribute.value == 0) && minAttribute.value != maxAttribute.value
                    ) {
                        let minValue = Math.floor(parseFloat(minAttribute.value));
                        let maxValue = Math.ceil(parseFloat(maxAttribute.value));
                        if (key == "f_sqm") {
                            btnSqm = `<div class="group-btn-sqm">
                                <span class="category-btn-sqm">Fabric Thickness</span>
                                <div class="group-btn-check">
                                    <button class="btn-check-sqm" data-id="${key}${minValue}-120" data-value="${minValue}-120"><span class="display-pc">Light：</span><span class="display-mb">Light</span><span class="value-number">~120g/㎡</span></button>
                                    <button class="btn-check-sqm" data-id="${key}121-300" data-value="121-300"><span class="display-pc">Medium：</span><span class="display-mb">Medium</span><span class="value-number">121~300g/㎡</span></button>
                                    <button class="btn-check-sqm" data-id="${key}301-${maxValue}" data-value="301-${maxValue}"><span class="display-pc">Heavy：</span><span class="display-mb">Heavy</span><span class="value-number">301~ g/㎡</span></button>
                                </div>
                            </div>`;
                        }
                        subFilterItem =`
                            <div class="boost-pfs-filter-block-content-inner-custom range-bar" data-id="${key}${minValue}-${maxValue}" data-value="${minValue}-${maxValue}" data-value-url="${minValue}-${maxValue}" data-value-default="${minValue}-${maxValue}" data-key="${key}" data-type="${filterList[key].type}">
                                <div class="boost-pfs-filter-option-range-amount-custom">
                                <div class="boost-pfs-filter-option-range-amount-wrapper-custom boost-pfs-filter-option-range-amount-min-wrapper-custom">
                                    <div class="boost-pfs-filter-option-range-slider-unit-custom">$</div>
                                    <input class="boost-pfs-filter-option-range-amount-min-custom range-input-value" role="textbox" type="text" aria-label="Min value" min="${minValue}" value="${minValue}">
                                </div>
                                <div class="boost-pfs-filter-option-range-amount-split-custom"> - </div>
                                <div class="boost-pfs-filter-option-range-amount-wrapper-custom boost-pfs-filter-option-range-amount-max-wrapper-custom">
                                    <div class="boost-pfs-filter-option-range-slider-unit-custom">$</div>
                                    <input class="boost-pfs-filter-option-range-amount-max-custom range-input-value" role="textbox" type="text" aria-label="Max value" max="${maxValue}" value="${maxValue}">
                                </div>
                                </div>
                                <div class="slider-wrapper">
                                <div id="slider-range${key}" class="slider-range-class"></div>
                                <div class="marker marker-0">${minValue}</div>
                                <div class="marker marker-25">${Math.floor(minValue + (maxValue-minValue) * 0.25)}</div>
                                <div class="marker marker-50">${Math.floor(minValue + (maxValue-minValue) * 0.50)}</div>
                                <div class="marker marker-75">${Math.floor(minValue + (maxValue-minValue) * 0.75)}</div>
                                <div class="marker marker-100">${maxValue}</div>
                                </div>
                                 ${btnSqm}
                            </div>`;
                        sliderInitObject = {
                            range: true,
                            min: minValue,
                            max: maxValue,
                            step: 1,
                            values: [minValue, maxValue]
                        }
                    } else {
                        return;
                    }
                } else if (filterList[key].type == filterType.checkbox && !filterList[key].be_return) {
                    let dataList = filterList[key].data;
                    let subFilterItemOptions = ``;
                    for (const dataListKey in dataList) {
                        subFilterItemOptions = subFilterItemOptions +
                            `<li class="boost-pfs-filter-option-item-custom boost-pfs-filter-option-label-custom item-value-custom ${filterList[key].type}" data-id="${dataList[dataListKey].key+dataList[dataListKey].value}" data-name="${dataList[dataListKey].value}" data-key="${dataList[dataListKey].key}" data-value="${dataList[dataListKey].value}" data-value-url="${dataList[dataListKey].value_url}" data-type="${filterList[key].type}">
                                <button role="checkbox" class="boost-pfs-filter-button-custom">
                                <span class="boost-pfs-check-box-custom" role="checkbox" tabindex="0" aria-labelledby="${dataList[dataListKey].value}"></span>
                                <span class="boost-pfs-filter-option-value-custom">${dataList[dataListKey].value}</span>
                                <span class="boost-pfs-filter-option-amount-custom" aria-label=""></span>
                                </button>
                            </li>`;
                    }
                    subFilterItem = `
                        <div class="boost-pfs-filter-option-content-inner-custom has-scrollbar">
                            <ul class="boost-pfs-filter-option-item-list-custom boost-pfs-filter-option-item-list-multiple-list-custom ${key}">
                                ${subFilterItemOptions}
                                </ul>
                        </div>`;
                }
                if (hasDataList) {
                    let subClassFilter = filterList[key].type == filterType.rangeBar ? 'range' : 'list';
                    let filterRefine = `<div class="boost-pfs-filter-tree-content-custom" aria-live="polite" role="navigation" aria-label="FILTER">
                        <div class="boost-pfs-filter-left-refine-by-wrapper-custom">
                          <div class="boost-pfs-filter-left-refine-by-custom">
                            <div class="boost-pfs-filter-left-refine-by-items-custom">
                              <button aria-label="Clear all filters" class="boost-pfs-filter-button-custom boost-pfs-filter-clear-all-custom" style="display: none;">Clear all</button>
                            </div>
                          </div>
                        </div>
                      </div>`;
                    let onOffPercent = '';
                    if (key === "f_formulation"){
                        onOffPercent = `<div class="on-off-percent">
                        <div class="boost-pfs-filter-left-on-off-percent">
                            <label class="switch">
                              <input type="checkbox" class="input-on-off-percent">
                              <span class="slider round"></span>
                            </label>
                            <span class="label-on-off-percent">100% only</span>
                        </div>
                    </div>`;
                    }
                    $(".boost-pfs-filter-options-wrapper-custom").append(`
                        <div class="boost-pfs-filter-option-custom boost-pfs-filter-option-${subClassFilter}-custom ${filterList[key].icon_class} boost-pfs-filter-has-scrollbar-custom boost-pfs-filter-option-column-1-custom boost-pfs-filter-option-collapsed-custom open-category" data-category="${index}">
                            <div class="boost-pfs-filter-option-title-custom">
                            <button aria-controls="boost-pfs-filter-tree-pf-m-::Item::${key}" aria-label="Filter by ${filterList[key].text}" tabindex="0" class="boost-pfs-filter-button-custom boost-pfs-filter-option-title-heading-custom" aria-expanded="false">
                                <span class="boost-pfs-filter-option-title-text-custom">${filterList[key].text}<span class="boost-pfs-filter-option-title-count-custom"></span></span>
                            </button>
                            <p class="boost-pfs-filter-selected-items-mobile-custom"></p>
                            <button aria-label="Clear filter by ${filterList[key].text}" class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">クリア</button>
                            </div>
                            <div class="boost-pfs-filter-option-content-custom toggled custom-content-filter-${key}" id="boost-pfs-filter-tree-pf-m-::Item::${key}">
                                <button class="close-search-collection">
                                    <svg class="Icon Icon--close " role="presentation" viewBox="0 0 16 14">
                                        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
                                    </svg>
                                </button>
                            ${filterRefine}
                            ${onOffPercent}
                            ${subFilterItem}
                            </div>
                        </div>
                    `);
                }
            }
            if (filterList[key].type == filterType.rangeBar && Object.keys(sliderInitObject).length > 0) {
                $(`#slider-range${key}`).slider(sliderInitObject);
                $(`#slider-range${key}`).slider({
                    slide: function(event, ui) {
                        $(event.target).parents('.range-bar').find('.boost-pfs-filter-option-range-amount-min-custom').val(ui.values[0]);
                        $(event.target).parents('.range-bar').find('.boost-pfs-filter-option-range-amount-max-custom').val(ui.values[1]);
                        $(this).data({
                            'value': parseInt(ui.value)
                        });
                    },
                    stop: function(event, ui) {
                        let rangeBarParentTarget = $(event.target).parents('.range-bar');
                        let oldValue = rangeBarParentTarget.attr('data-value');
                        let newValue = `${ui.values[0]}-${ui.values[1]}`;
                        let dataId = rangeBarParentTarget.attr('data-id');
                        let dataType = rangeBarParentTarget.attr('data-type');
                        let dataKey = rangeBarParentTarget.attr('data-key');
                        let defaultValue = rangeBarParentTarget.attr('data-value-default');
                        if (oldValue != newValue) {
                            openFilterLoading();
                            let data = {
                                'action' : defaultValue != newValue ? filterAction.change : filterAction.changeToDefault,
                                'id' : dataId,
                                'type' : dataType,
                                'key' : dataKey,
                                'value' : newValue,
                            };
                            // call API
                            let searchStatus = searchFilterFunction(data);
                            if (searchStatus) {
                                $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                                rangeBarParentTarget.attr('data-value', newValue);
                                if (defaultValue != newValue) {
                                    let dataValue = newValue;
                                    if (ui.values[0] == ui.values[1]) {
                                        dataValue = ui.values[0];
                                    }
                                    $('.boost-pfs-filter-refine-by-items-custom').append(
                                        `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValue}" data-type="${dataType}">
                                        <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                            <span class="refine-by-type-custom">
                                            <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataValue}</span>
                                            </span>
                                        </button>
                                        </div>`
                                    );
                                }
                                showOrHideClearButton();
                                setTimeout(function () {
                                    cancelFilterLoading();
                                }, 0);
                            }
                        }
                    }
                });
            }
        });
    });

    let renderStatus = renderDataByUrl();
    showOrHideClearButton();
    if (renderStatus) {
        setTimeout(function () {
            cancelFilterLoading();
        }, 0);
    } else {
        cancelFilterLoading();
    }
    if (!isLogin) {
        greyOutFilter();
    }
});

function greyOutFilter() {
    let greyFilters = [
        'f_sqm',
        'f_dye_origin_cd',
        'dye_method_name',
        'f_finishing_category_cd',
        'colors',
        'shopify_collection',
        'price_by_company',
    ];
    if (authenticationKeyStatus) {
        greyFilters = [];
    }
    const filterOptionEls = document.querySelectorAll('.boost-pfs-filter-option-custom');
    filterOptionEls.forEach(filterOption => {
        const filterOptionBtn = filterOption.querySelector('button.boost-pfs-filter-option-title-heading-custom');
        const filterName = filterOptionBtn.getAttribute('aria-controls').split('::Item::')[1];
        if (greyFilters.includes(filterName)) {
            filterOption.style.cssText = `
                opacity: 0.5;
                cursor: default;
                pointer-events: none;
            `;
            filterOptionBtn.style.cssText = `
                cursor: default;
                pointer-events: none;
            `;
        }
    })
}

function renderSortOptions() {
    const sortType = $('#collection_sort_option');
    const newArrival = sortType.attr('data-new-arrival');
    const styleCodeAsc = sortType.attr('data-style-code-asc');
    const styleCodeDesc = sortType.attr('data-style-code-desc');
    const priceAsc = sortType.attr('data-price-asc');
    const priceDesc = sortType.attr('data-price-desc');
    const arraySortOption = [newArrival, styleCodeAsc, styleCodeDesc, priceAsc, priceDesc];
    let sortListConvert = [...sortList];
    if (!customerIdCheck && authenticationKeyStatus) {
        sortListConvert = sortList.filter(item => item.sort_field !== 'price_by_company')
    }
    Object.keys(sortListConvert).forEach(function(key) {
        sortListConvert[key].text = arraySortOption[key];
        if((sortListConvert[key].display_page == displayPage.all || sortListConvert[key].display_page == thisPage)
            && (sortListConvert[key].display_condition == displayCondition.all || (sortListConvert[key].display_condition == displayCondition.logged && (customerIdCheck || authenticationKeyStatus)))
        ) {
            $('.Popover__Content .Popover__ValueList').append(`
                <button class="Popover__Value ${ sortListConvert[key].default && (sortListConvert[key].default_page == displayPage.all || sortListConvert[key].default_page == thisPage)  ? 'is-selected': '' } Heading Link Link--primary u-h6" data-sort-field="${ sortListConvert[key].sort_field }" data-sort-value="${ sortListConvert[key].sort_type }" data-action="select-value-custom">
                    ${ sortListConvert[key].text }
                    <svg class="Icon Icon--checkmark " role="presentation" viewBox="0 0 24 24">
                      <polygon fill="currentColor" points="9,20 2,13 5,10 9,14 19,4 22,7 "></polygon>
                    </svg>
                </button>
            `);
        }
    });
}

function renderDataByUrl() {
    let searchData = {
        action : filterAction.changeToDefault
    }
    let pathName = window.location.pathname;
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    urlParams = Array.from(urlParams);
    let sortOptionCheck = {};

    let entries = []
    let keyEntry = '';
    let valueEntry = '';
    for (let i = 0; i < urlParams.length; i++){
        if (urlParams[i][1]){
            if (i !== 0){
                entries.push([keyEntry, valueEntry])
                keyEntry = '';
                valueEntry = ''
            }
            keyEntry = urlParams[i][0]
            valueEntry += urlParams[i][1]
        } else {
            valueEntry += '&' + urlParams[i][0]
        }

        if (i === urlParams.length - 1){
            entries.push([keyEntry, valueEntry])
        }
    }
    // let isLogin = customerIdCheck ? true : false;
    // if (isLogin || authenticationKeyStatus) {
        for(const entry of entries) {
            if (reverseList[entry[0]]) {
                let dataType = reverseList[entry[0]].type;
                if (dataType == filterType.singleSelect || dataType == filterType.checkbox) {
                    let dataKey = entry[0];
                    let dataValues = dataType == filterType.checkbox ? entry[1].split(',') : [entry[1]];
                    let dataValuesLength = dataValues.length;
                    for (let i = 0; i < dataValuesLength; i++) {
                        let dataValueUrl = dataValues[i];
                        let dataId = `${dataKey}${dataValueUrl}`;
                        let elementFilterOption = $(`.boost-pfs-filter-option-content-inner-custom [data-id="${dataId}"]`);
                        if (elementFilterOption.length === 0) {
                            elementFilterOption = $(`.boost-pfs-filter-option-content-inner-custom [data-key="${dataKey}"][data-value-url="${dataValueUrl}"]`);
                        }
                        if (elementFilterOption.length === 0 && dataKey === 'organization_taxonomy') {
                            elementFilterOption = $(`.category-group-lever-2 [data-key="${dataKey}"][data-value="${dataValueUrl}"]`);
                        }
                        if (dataKey ==='f_textile_class') {
                            $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).addClass('selected');
                            let dataName = $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).attr('data-name');
                            let dataValueUrl = $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).attr('data-value-url');
                            let dataValue = $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).attr('data-value-url');
                            $('.boost-pfs-filter-refine-by-items-custom').append(
                                `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                    <span class="re fine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                    </span>
                                </button>
                                </div>`
                            );
                            $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).parents('.category-group-lever-1').find('.category-group-lever-2 .checkbox-lever-2,.category-group-lever-2 .item-value-custom').addClass('selected');
                        } else if(dataKey === 'organization_taxonomy') {
                            if (elementFilterOption.length > 0) {
                                let dataValue = elementFilterOption.attr('data-value');
                                dataId = elementFilterOption.attr('data-id');
                                let dataName = elementFilterOption.attr('data-name');
                                let dataValueUrl = elementFilterOption.attr('data-value-url');
                                $('.boost-pfs-filter-refine-by-items-custom').append(
                                    `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                    <span class="re fine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                    </span>
                                </button>
                                </div>`
                                );
                                $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-custom').addClass('selected');
                                if ($(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).parents('.category-group-lever-1').find('.category-group-lever-2 .checkbox-lever-2').not('.selected').length === 0) {
                                    $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).parents('.category-group-lever-1').find('.checkbox-lever-1').addClass('selected');
                                }
                                elementFilterOption.addClass('selected');
                            }
                        } else if (dataKey === 'is_composition_absolute' && dataValueUrl == 'true') {
                            $(".input-on-off-percent").prop("checked", true);
                            $('.boost-pfs-filter-left-on-off-percent').addClass('checked');
                        } else {
                            if (elementFilterOption.length > 0) {
                                let dataValue = elementFilterOption.attr('data-value');
                                dataId = elementFilterOption.attr('data-id');
                                let dataName = elementFilterOption.attr('data-name');
                                $('.boost-pfs-filter-refine-by-items-custom').append(
                                    `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                            <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                <span class="refine-by-type-custom">
                                <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                </span>
                            </button>
                            </div>`
                                );
                                elementFilterOption.addClass('selected');
                            } else if ($(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).length > 0) {
                                $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).addClass('selected');
                                let dataName = $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).attr('data-name');
                                let dataValueUrl = $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).attr('data-value-url');
                                let dataValue = $(`.boost-pfs-filter-option-item-custom-top[data-id="${dataId}"]`).attr('data-value-url');
                                $('.boost-pfs-filter-refine-by-items-custom').append(
                                    `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                    <span class="re fine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                    </span>
                                </button>
                                </div>`
                                );
                            }
                        }
                    }
                } else if (dataType == filterType.rangeBar) {
                    let dataKey = entry[0].replace(`_${reverseList[entry[0]].position}`, '');
                    let dataRangebar = $(`.boost-pfs-filter-block-content-inner-custom.range-bar[data-key="${dataKey}"]`);
                    if (dataRangebar.length > 0) {
                        let value = entry[1];
                        let dataId = dataRangebar.attr('data-id');
                        let sliderDefaultValues = dataRangebar.attr('data-value-default').split('-').map(function(item) {
                            return parseInt(item);
                        });
                        let sliderValues = dataRangebar.find('.slider-range-class').slider('values');
                        if (reverseList[entry[0]].position == 'min' && !isNaN(value)) {
                            value =  parseInt(value);
                            value = value < sliderDefaultValues[0] ? sliderDefaultValues[0]
                                : (value > sliderValues[1] ? sliderValues[1] : value);
                            dataRangebar.find(`.boost-pfs-filter-option-range-amount-${reverseList[entry[0]].position}-custom.range-input-value`).val(value);
                            sliderValues[0] = value;
                            dataRangebar.find('.slider-range-class').slider('values', 0, value);
                        } else if (reverseList[entry[0]].position == 'max' && !isNaN(value)) {
                            value =  parseInt(value);
                            value = value > sliderDefaultValues[1] ? sliderDefaultValues[1]
                                : (value < sliderValues[0] ? sliderValues[0] : value);
                            dataRangebar.find(`.boost-pfs-filter-option-range-amount-${reverseList[entry[0]].position}-custom.range-input-value`).val(value);
                            sliderValues[1] = value;
                            dataRangebar.find('.slider-range-class').slider('values', 1, value);
                        }
                        let dataValue =  sliderValues[0] == sliderValues[1]
                            ? `${sliderValues[0]}`
                            : `${sliderValues[0]}-${sliderValues[1]}`;
                        $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                        $('.boost-pfs-filter-refine-by-items-custom').append(
                        `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValue}" data-type="${dataType}">
                            <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                            <span class="refine-by-type-custom">
                                <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataValue}</span>
                            </span>
                            </button>
                        </div>`
                        );
                    }
                }
            } else if (entry[0] == 'page') {
                searchData[entry[0]] = entry[1];
            } else if(entry[0] == 'sort_field' || entry[0] == 'sort_type') {
                searchData[entry[0]] = entry[1];
                sortOptionCheck[entry[0]] = entry[1];
            } else if (entry[0] == 'q' && thisPage == displayPage.pageSearch) {
                searchData.search_box = entry[1];
                $('#Search .Search__Input, #SearchMb .Search__Input').val(entry[1]);
                $('.boost-pfs-filter-refine-by-items-custom').append(
                  `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${entry[0]}" data-key="${entry[0]}" data-value="${entry[1]}" data-value-url="${entry[1]}" data-name="${entry[0]}" data-type="type_search">
                    <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                      <span class="refine-by-type-custom">
                        <span class="refine-by-option-custom"></span>
                        <span class="refine-by-value-custom">${hashtagKeyword}${entry[1]}</span>
                      </span>
                    </button>
                  </div>`
                );
            } else if (entry[0] == 'product_id' && thisPage == displayPage.pageSearch) {
                searchData.search_box = entry[1];
                $('#Search .Search__Input, #SearchMb .Search__Input').val(entry[1]);
                $('.boost-pfs-filter-refine-by-items-custom').append(
                  `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${entry[0]}" data-key="${entry[0]}" data-value="${entry[1]}" data-value-url="${entry[1]}" data-name="${entry[0]}" data-type="type_search">
                    <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                      <span class="refine-by-type-custom">
                        <span class="refine-by-option-custom"></span>
                        <span class="refine-by-value-custom">${hashtagProductId}${entry[1]}</span>
                      </span>
                    </button>
                  </div>`
                );
            } else if (entry[0] == 'search_box_sidebar' && thisPage == displayPage.pageSearch) {
                searchData.search_box_sidebar = entry[1];
                $('.boost-pfs-filter-left-col-custom .Search__Input[name="search_box_sidebar"]').val(entry[1]);
            }
        }
        if (Object.keys(sortOptionCheck).length == 2) {
            $('.Popover__Content .Popover__ValueList .is-selected[data-action="select-value-custom"]').removeClass('is-selected');
            $(`.Popover__Content .Popover__ValueList [data-action="select-value-custom"][data-sort-field="${sortOptionCheck.sort_field}"][data-sort-value="${sortOptionCheck.sort_type}"]`).addClass('is-selected');
            const sortText = $(`.Popover__Content .Popover__ValueList [data-action="select-value-custom"][data-sort-field="${sortOptionCheck.sort_field}"][data-sort-value="${sortOptionCheck.sort_type}"]`).text().trim();
            $('.CollectionToolbar__Item.btn-open-sort span').text(sortText);
        }
    // }

    return searchFilterFunction(searchData);
}


// checkbox and singlebox and boolean change
$(document).on('click','.item-value-custom', function (e) {
    e.preventDefault();
    e.stopPropagation();
    openFilterLoading();
    let dataId = $(this).attr('data-id');
    let dataKey = $(this).attr('data-key');
    let dataValue = $(this).attr('data-value');
    let dataType = $(this).attr('data-type');
    let dataName = $(this).attr('data-name');
    let dataValueUrl = $(this).attr('data-value-url');
    let thisAction = $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).length > 0
                    ? filterAction.delete : filterAction.add;
    if (dataKey === 'organization_taxonomy') {
        thisAction = $(this).closest('.checkbox-lever-2').hasClass('selected')  ? filterAction.delete : filterAction.add;
    } else if (dataKey === 'construction_name_name'){
        thisAction = $(this).hasClass('selected')  ? filterAction.delete : filterAction.add;
    }
    let data = {
        'action' : thisAction,
        'id' : dataId,
        'type' : dataType,
        'key' : dataKey,
        'value' : dataValue,
        'valueUrl': dataValueUrl
    };

    if (thisAction) {
        if (dataKey === 'f_textile_class' && thisAction === filterAction.add) {
            $(this).parents('.category-group-lever-1').find('.category-group-lever-2 .checkbox-lever-2,.category-group-lever-2 .item-value-custom').addClass('selected');
        } else if (dataKey === 'f_textile_class' && thisAction === filterAction.delete) {
            $(this).parents('.category-group-lever-1').find('.category-group-lever-2 .checkbox-lever-2,.category-group-lever-2 .item-value-custom').removeClass('selected');
        }
        if (dataKey === 'organization_taxonomy' && thisAction === filterAction.add) {
            $(this).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-custom').addClass('selected');
            if ($(this).parents('.category-group-lever-1').find('.category-group-lever-2 .checkbox-lever-2').not('.selected').length === 1) {
                $(this).parents('.category-group-lever-1').find('.checkbox-lever-1').addClass('selected');
            }
        } else if (dataKey === 'organization_taxonomy' && thisAction === filterAction.delete) {
            $(this).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-custom').removeClass('selected');
            $(this).parents('.category-group-lever-1').find('.checkbox-lever-1').removeClass('selected');
        }

        if (dataKey === 'construction_name_name' && thisAction === filterAction.add) {
            if ($(this).parents('.organization_taxonomy-custom').find('.boost-pfs-filter-option-item-custom').not('.selected').length === 1) {
                $(this).parents('.category-group-lever-2').find('.checkbox-lever-2').addClass('selected');
            }
            if ($(this).parents('.category-group-lever-1').find('.category-group-lever-2 .checkbox-lever-2').not('.selected').length === 0) {
                $(this).parents('.category-group-lever-1').find('.checkbox-lever-1').addClass('selected');
            }
        } else if (dataKey === 'construction_name_name' && thisAction === filterAction.delete) {
            $(this).parents('.category-group-lever-2').find('.checkbox-lever-2').removeClass('selected');
            $(this).parents('.category-group-lever-1').find('.checkbox-lever-1').removeClass('selected');
        }
        if (!$(this).hasClass('selected') && $(this).hasClass(filterType.singleSelect)) {
            $(this).parents('.boost-pfs-filter-option-item-list-custom').find('.item-value-custom.selected').removeClass('selected');
            $(`.boost-pfs-filter-refine-by-items-custom [data-key="${dataKey}"]`).remove();
        }
        if ($(this).hasClass('selected') && ($(this).hasClass(filterType.checkbox))) {
            $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
            $(this).removeClass('selected');
            if (dataKey === 'organization_taxonomy') {
                let ElementLv1 = $(this).parents('.category-group-lever-1').find('.checkbox-lever-1');
                dataId = ElementLv1.attr('data-id');
                $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                let ListElementLv2 = $(this).parents('.category-group-lever-1').find('.category-group-lever-2');
                ListElementLv2.each(function(index, element) {
                    let ElementLv2 = $(element).find('.checkbox-lever-2');
                    if ($(ElementLv2).hasClass('selected')) {
                        dataId = ElementLv2.attr('data-id');
                        dataKey =  ElementLv2.attr('data-key');
                        dataValue = ElementLv2.attr('data-value');
                        dataType = ElementLv2.attr('data-type');
                        dataName = ElementLv2.attr('data-name');
                        dataValueUrl = ElementLv2.attr('data-value-url');
                        $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                        $('.boost-pfs-filter-refine-by-items-custom').append(
                            `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                <span class="refine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                </span>
                                </button>
                            </div>`
                        );
                    }
                });
            } else if (dataKey === 'construction_name_name') {
                $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                $(this).removeClass('selected');
                let ElementLv1 = $(this).parents('.category-group-lever-1').find('.checkbox-lever-1');
                let dataIdLv1 = ElementLv1.attr('data-id');
                $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataIdLv1}"]`).remove();
                let ListElementLv2 = $(this).parents('.category-group-lever-1').find('.category-group-lever-2');
                ListElementLv2.each(function(index, element) {
                    let ElementLv2 = $(element).find('.checkbox-lever-2');
                    dataId = ElementLv2.attr('data-id');
                    $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                    if ($(ElementLv2).hasClass('selected')) {
                        dataKey =  ElementLv2.attr('data-key');
                        dataValue = ElementLv2.attr('data-value');
                        dataType = ElementLv2.attr('data-type');
                        dataName = ElementLv2.attr('data-name');
                        dataValueUrl = ElementLv2.attr('data-value-url');
                        $('.boost-pfs-filter-refine-by-items-custom').append(
                            `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                <span class="refine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                </span>
                                </button>
                            </div>`
                        );
                    }
                });
                let ListElementLv3 = $(this).parents('.boost-pfs-filter-option-item-list-custom').find('.boost-pfs-filter-option-item-custom');
                ListElementLv3.each(function(index, element) {
                    let ElementLv3 = $(element);
                    if ($(ElementLv3).hasClass('selected')) {
                        dataId = ElementLv3.attr('data-id');
                        dataKey =  ElementLv3.attr('data-key');
                        dataValue = ElementLv3.attr('data-value');
                        dataType = ElementLv3.attr('data-type');
                        dataName = ElementLv3.attr('data-name');
                        dataValueUrl = ElementLv3.attr('data-value-url');
                        $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                        $('.boost-pfs-filter-refine-by-items-custom').append(
                            `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                <span class="refine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                </span>
                                </button>
                            </div>`
                        );
                    }
                });
            }
        } else if ($(this).hasClass('selected') && $(this).hasClass(filterType.singleSelect)) {
            $(this).parents('.boost-pfs-filter-option-item-list-custom').find('.item-value-custom.selected').removeClass('selected');
            $(`.boost-pfs-filter-refine-by-items-custom [data-key="${dataKey}"]`).remove();
        } else {
            $(this).addClass('selected');
            if (dataKey === 'organization_taxonomy') {
                if ($(this).parents('.category-group-lever-1').find('.checkbox-lever-1').hasClass('selected')) {
                    let ElementLv1 = $(this).parents('.category-group-lever-1').find('.checkbox-lever-1');
                    dataId = ElementLv1.attr('data-id');
                    dataKey =  ElementLv1.attr('data-key');
                    dataValue = ElementLv1.attr('data-value');
                    dataType = ElementLv1.attr('data-type');
                    dataName = ElementLv1.attr('data-name');
                    dataValueUrl = ElementLv1.attr('data-value-url');
                    $(`.boost-pfs-filter-refine-by-items-custom [data-key="organization_taxonomy"]`).remove();
                    $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                    $('.boost-pfs-filter-refine-by-items-custom').append(
                        `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                            <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                            <span class="refine-by-type-custom">
                                <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                            </span>
                            </button>
                        </div>`
                    );
                } else {
                    let ListElementLv2 = $(this).parents('.category-group-lever-1').find('.category-group-lever-2');
                    ListElementLv2.each(function(index, element) {
                        let ElementLv2 = $(element).find('.checkbox-lever-2');
                        if ($(ElementLv2).hasClass('selected')) {
                            dataId = ElementLv2.attr('data-id');
                            dataKey =  ElementLv2.attr('data-key');
                            dataValue = ElementLv2.attr('data-value');
                            dataType = ElementLv2.attr('data-type');
                            dataName = ElementLv2.attr('data-name');
                            dataValueUrl = ElementLv2.attr('data-value-url');
                            $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                            $('.boost-pfs-filter-refine-by-items-custom').append(
                                `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                <span class="refine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                </span>
                                </button>
                            </div>`
                            );
                        }
                    });
                    let ListElementLv3 = $(this).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-custom');
                    ListElementLv3.each(function(index, element) {
                        let dataIdRemoveLv3 = $(element).attr('data-id');
                        $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataIdRemoveLv3}"]`).remove();
                    });
                }
            } else if (dataKey === 'f_textile_class'){
                let ListElementLv2 = $(this).parents('.category-group-lever-1').find('.category-group-lever-2');
                ListElementLv2.each(function(index, element) {
                    let ElementLv2 = $(element).find('.checkbox-lever-2');
                    $(`.boost-pfs-filter-refine-by-items-custom [data-id="${ElementLv2.attr('data-id')}"]`).remove();
                    let ListElementLv3 = $(element).find('.boost-pfs-filter-option-item-custom');
                    ListElementLv3.each(function(item, elementlv3) {
                        $(`.boost-pfs-filter-refine-by-items-custom [data-id="${$(elementlv3).attr('data-id')}"]`).remove();
                    });
                });
                $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                $('.boost-pfs-filter-refine-by-items-custom').append(
                    `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                            <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                            <span class="refine-by-type-custom">
                                <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                            </span>
                            </button>
                        </div>`
                );
            } else if (dataKey === 'construction_name_name') {
                $('.boost-pfs-filter-refine-by-items-custom').append(
                    `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                    <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                    <span class="refine-by-type-custom">
                        <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                    </span>
                    </button>
                </div>`
                );
                if ($(this).parents('.category-group-lever-2').find('.checkbox-lever-2').hasClass('selected')) {
                    let ElementLv2 = $(this).parents('.category-group-lever-2').find('.checkbox-lever-2');
                    let ListElementLv3 = $(this).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-custom');
                    dataId = ElementLv2.attr('data-id');
                    $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                    if ($(ElementLv2).hasClass('selected')) {
                        ListElementLv3.each(function(index, element) {
                            $(`.boost-pfs-filter-refine-by-items-custom [data-id="${$(element).attr('data-id')}"]`).remove();
                        });
                        dataKey =  ElementLv2.attr('data-key');
                        dataValue = ElementLv2.attr('data-value');
                        dataType = ElementLv2.attr('data-type');
                        dataName = ElementLv2.attr('data-name');
                        dataValueUrl = ElementLv2.attr('data-value-url');
                        $('.boost-pfs-filter-refine-by-items-custom').append(
                            `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                                <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                                <span class="refine-by-type-custom">
                                    <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                                </span>
                                </button>
                            </div>`
                        );
                    }
                }
                if ($(this).parents('.category-group-lever-1').find('.checkbox-lever-1').hasClass('selected')) {
                    $(`.boost-pfs-filter-refine-by-items-custom [data-key="construction_name_name"]`).remove();
                    $(`.boost-pfs-filter-refine-by-items-custom [data-key="organization_taxonomy"]`).remove();
                    let ElementLv1 = $(this).parents('.category-group-lever-1').find('.checkbox-lever-1');
                    dataId = ElementLv1.attr('data-id');
                    dataKey =  ElementLv1.attr('data-key');
                    dataValue = ElementLv1.attr('data-value');
                    dataType = ElementLv1.attr('data-type');
                    dataName = ElementLv1.attr('data-name');
                    dataValueUrl = ElementLv1.attr('data-value-url');
                    $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
                    $('.boost-pfs-filter-refine-by-items-custom').append(
                        `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                            <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                            <span class="refine-by-type-custom">
                                <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                            </span>
                            </button>
                        </div>`
                    );
                }
            } else {
                $('.boost-pfs-filter-refine-by-items-custom').append(
                    `<div class="refine-by-item-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                    <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                    <span class="refine-by-type-custom">
                        <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                    </span>
                    </button>
                </div>`
                );
            }
        }
    }
    // call API
    let searchStatus = searchFilterFunction(data);
    showOrHideClearButton();
    setTimeout(function () {
        cancelFilterLoading();
    }, 0);
});

const clearSearchHeader = function () {
  openFilterLoading();
  $(".clear-search-header").hide();
  $(".Search__Form .Search__Input").val("");
  const url = new URL(window.location.href);
  url.searchParams.delete('q');
  url.searchParams.delete('product_id');
  window.history.replaceState(null, null, url.toString());
  $('.boost-pfs-filter-refine-by-items-custom [data-id]').remove();
  renderDataByUrl();
  showOrHideClearButton();
  setTimeout(function () {
    cancelFilterLoading();
    const inputType = $('.type-search-header').val();
    const htmlQuickLink = `
      <div class="boost-pfs-search-quick-link">
        <p class="title">Quicklink</p>
        ${quick_link_header_key_word}
      </div>`;
    const htmlQuickLinkPrdId = `
      <div class="boost-pfs-search-quick-link">
        <p class="title">Quicklink</p>
        ${quick_link_product_id}
      </div>`;
    if (inputType == 1){
      if (quick_link_product_id != ''){
        $('#stm-install-search-results').html('').append(htmlQuickLinkPrdId);
      }
    } else{
      if (quick_link_header_key_word != ''){
        $('#stm-install-search-results').html('').append(htmlQuickLink);
      }
    }
  }, 0);
}

// all box change
$(document).on('click','.boost-pfs-filter-refine-by-items-custom .boost-pfs-filter-clear-custom, .boost-pfs-filter-left-refine-by-items-custom .boost-pfs-filter-clear-custom', function (e) {
    openFilterLoading();
    e.preventDefault();
    e.stopPropagation();
    let dataId = '';
    let dataKey = '';
    let dataValue = '';
    let dataType = '';
    if ($(this).parents('.refine-by-item-custom').length > 0){
        dataId = $(this).parents('.refine-by-item-custom').attr('data-id');
        dataKey = $(this).parents('.refine-by-item-custom').attr('data-key');
        dataValue = $(this).parents('.refine-by-item-custom').attr('data-value');
        dataType = $(this).parents('.refine-by-item-custom').attr('data-type');
    } else {
        dataId = $(this).parents('.refine-by-item-left-custom').attr('data-id');
        dataKey = $(this).parents('.refine-by-item-left-custom').attr('data-key');
        dataValue = $(this).parents('.refine-by-item-left-custom').attr('data-value');
        dataType = $(this).parents('.refine-by-item-left-custom').attr('data-type');
    }
    let data = {
        'action' : filterType.delete,
        'id' : dataId,
        'type' : dataType,
        'key' : dataKey,
        'value' : dataValue,
    };
    // call API
    let searchStatus = searchFilterFunction(data);
    if (searchStatus) {
        $(`.boost-pfs-filter-refine-by-items-custom [data-id="${dataId}"]`).remove();
        if(dataKey == 'organization_taxonomy'){
            let ListElementLv3 = $(`.checkbox-lever-2[data-id="${dataId}"]`).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-custom');
            ListElementLv3.each(function(index, element) {
                $(element).removeClass('selected');
            });
        }
        if(dataKey == 'f_textile_class'){
            let ListElementLv2 = $(`.checkbox-lever-1[data-id="${dataId}"]`).parents('.category-group-lever-1').find('.category-group-lever-2');
            ListElementLv2.each(function(index, element) {
                $(element).find('.checkbox-lever-2').removeClass('selected');
                let ListElementLv3 = $(element).find('.boost-pfs-filter-option-item-custom');
                ListElementLv3.each(function(item, elementlv3) {
                    $(elementlv3).removeClass('selected');
                });
            });
        }
        if (dataType == filterType.checkbox || dataType == filterType.singleSelect) {
            $(`.boost-pfs-filter-option-item-list-custom .item-value-custom[data-id="${dataId}"]`).removeClass('selected');
            $(`.boost-pfs-filter-option-item-custom-top.item-value-custom[data-id="${dataId}"]`).removeClass('selected');
        } else if (dataType == filterType.rangeBar) {
            let valueArray = dataId.replace(dataKey, '').split('-').map(function(item) {
                return parseInt(item);
            });
            $(`#slider-range${dataKey}`).slider('values', 0, valueArray[0]);
            $(`[data-id="${dataId}"] .boost-pfs-filter-option-range-amount-min-custom`).val(valueArray[0]);
            $(`#slider-range${dataKey}`).slider('values', 1, valueArray[1]);
            $(`[data-id="${dataId}"] .boost-pfs-filter-option-range-amount-max-custom`).val(valueArray[1]);
        } else if (dataType === 'type_search') {
          clearSearchHeader();
        }
        showOrHideClearButton();
    }
    setTimeout(function () {
        cancelFilterLoading();
    }, 0);
  });

// all box clear all
$(document).on('click','.boost-pfs-filter-refine-by-custom .boost-pfs-filter-clear-all-custom, .btn-clear-all-mb, .boost-pfs-filter-left-refine-by-custom .boost-pfs-filter-clear-all-custom', function (e) {
    //remove all URL parameters if intentionally cleared
    let url = window.location.href;
    let cleanURL = url.split('?')[0];
    window.history.replaceState({}, document.title, cleanURL);
    openFilterLoading();
    e.preventDefault();
    e.stopPropagation();
    let data = {
        'action' : filterAction.deleteAll,
    };
    $('.check-clear-all').val("1");
    // call API
    let searchStatus = searchFilterFunction(data);
    if (searchStatus) {
        $(`.boost-pfs-filter-refine-by-items-custom [data-id]`).remove();
        $('.boost-pfs-filter-option-list-custom').find('.item-value-custom.selected').removeClass('selected');
        $('.CollectionToolbar__Group--left').find('.boost-pfs-filter-option-item-custom-top').removeClass('selected');
        $('.boost-pfs-filter-block-content-inner-custom.range-bar').each(function() {
            let values = $(this).attr('data-value-default').split('-').map(function(item) {
                return parseInt(item);
            });
            $(this).find('.boost-pfs-filter-option-range-amount-min-custom.range-input-value').val(values[0]);
            $(this).find('.slider-range-class').slider('values', 0, values[0]);
            $(this).find('.boost-pfs-filter-option-range-amount-max-custom.range-input-value').val(values[1]);
            $(this).find('.slider-range-class').slider('values', 1, values[1]);
        });
        $('.btn-check-sqm').removeClass('checked');
        clearSearchHeader();
        showOrHideClearButton();
    }
    setTimeout(function () {
        cancelFilterLoading();
    }, 0);
});

function searchFilterFunction(data) {
    let isLogin = customerIdCheck ? true : false;
    let dataParams = {
        is_login: isLogin,
        per_page: PER_PAGE,
        page: data.page && isLogin ? data.page : 1,
        format_response: 1
    }

    let sortData = getSortParams();
    dataParams = { ...dataParams, ...sortData };
    if (typeof data.sort_field !== 'undefined') {
        dataParams.sort_field = data.sort_field;
    }
    if (typeof data.sort_type !== 'undefined') {
        dataParams.sort_type = data.sort_type;
    }
    let pathName = window.location.pathname;
    if (pathName == '/search') {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let searchBox = urlParams.get('q');
        let productId = urlParams.get('product_id');
        let searchBoxSidebar = urlParams.get('search_box_sidebar');

        if (searchBox) {
            dataParams.search_box = searchBox;
        } else if (productId) {
            dataParams.product_id = productId;
        } else if (searchBoxSidebar) {
            dataParams.search_box_sidebar = searchBoxSidebar;
        }
    }
    if (thisPage == displayPage.pageCollection && pathName != "/collections/all" && collectionName) {
        dataParams['collection'] = collectionName
    }
    let loginCompanyCode = '';
    if (isLogin) {
        loginCompanyCode = localStorage.getItem('current_company') || '';
        loginCompanyType = localStorage.getItem('current_company_type') || '';
        dataParams['company_code'] = loginCompanyCode;
        dataParams['company_type'] = loginCompanyType;
    }
    else {
      if (authenticationKeyStatus) {
        dataParams['is_login'] = true;
        dataParams['page'] = data.page;
        dataParams['company_code'] = companyRepresentativeGlobal;
        dataParams['company_type'] = 'null';
      }
    }
    if ($('.input-on-off-percent').is(':checked')) {
        dataParams['is_composition_absolute'] = true;
    }
    if (data.action != filterAction.deleteAll) {
        $('.boost-pfs-filter-refine-by-items-custom .refine-by-item-custom').each(function() {
            let dataId = $(this).attr('data-id');
            let dataKey = $(this).attr('data-key');
            let dataValue = $(this).attr('data-value');
            let dataType = $(this).attr('data-type');
            if (dataType == filterType.checkbox && data.id != dataId) {
                dataParams[dataKey] = dataParams[dataKey] ? `${dataParams[dataKey]},${dataValue}` : dataValue;
            } else if (dataType == filterType.singleSelect && data.key != dataKey) {
                dataParams[dataKey] = dataValue;
            } else if (dataType == filterType.rangeBar && data.id != dataId) {
                let values = dataValue.split('-').map(function(item) {
                return parseInt(item);
                });
                let paramKeyMin = `${dataKey}_min`;
                let paramKeyMax = `${dataKey}_max`;
                dataParams[paramKeyMin] = values[0];
                dataParams[paramKeyMax] = values.length > 1 ? values[1] : values[0];
            }
        });

        if (data.action == filterAction.add) {
            if ((data.key === 'organization_taxonomy' && $(`.checkbox-lever-2[data-id="${data.id}"]`).parents('.category-group-lever-1').find('.checkbox-lever-1').hasClass('selected')) ||
                data.key === 'construction_name_name' && $(`.item-value-custom[data-id="${data.id}"]`).parents('.category-group-lever-2').find('.checkbox-lever-2').hasClass('selected')
            ) {
                //
            } else {
                if (data.type == filterType.checkbox) {
                    dataParams[data.key] = dataParams[data.key] ? `${dataParams[`${data.key}`]},${data.value}` : data.value;
                } else if (data.type == filterType.singleSelect) {
                    dataParams[data.key] = data.value;
                }
            }
        } else if (data.action == filterAction.change && data.type == filterType.rangeBar) {
            let values = data.value.split('-').map(function(item) {
                return parseInt(item);
            });
            let paramKeyMin = `${data.key}_min`;
            let paramKeyMax = `${data.key}_max`;
            dataParams[paramKeyMin] = values[0];
            dataParams[paramKeyMax] = values.length > 1 ? values[1] : values[0];
        };
    }
    let responseData = getItems(dataParams);
    if (responseData && Object.keys(responseData).length > 0) {
        renderUrlParams(responseData.params, responseData.pageInfo);
        renderProductItems(responseData.productItems, responseData.params);
        renderPages(responseData.pageInfo);
        return true;
    } else {
        return false;
    }
}

function appendSearchLeftFilter() {
    const sourceElements = $(".boost-pfs-filter-refine-by-items-custom .refine-by-item-custom");
    $('.boost-pfs-filter-left-refine-by-items-custom [data-id]').remove();
    $('.category-group-lever-2').removeClass('checked');
    $('.boost-pfs-filter-option-item-custom[data-key="f_formulation"]').removeClass('no-percent-100');
    if (sourceElements.length > 0) {
        sourceElements.each(function() {
            let dataId = $(this).attr('data-id');
            let dataKey = $(this).attr('data-key');
            let dataValue = $(this).attr('data-value');
            let dataType = $(this).attr('data-type');
            let dataName = $(this).attr('data-name');
            let dataValueUrl = $(this).attr('data-value-url');
            let dataCompositionAbsolute = $(this).attr('data-composition-absolute');
            if (dataKey !== 'quality_report' && dataKey !== 'product_stock') {
                if (dataType === filterType.rangeBar || dataKey === 'product_id' || dataKey === 'q') {
                    dataName =  $(this).find(".refine-by-value-custom").html();
                }
                if (dataKey === 'organization_taxonomy') {
                    $(`.checkbox-lever-2[data-id="${dataId}"]`).parents('.category-group-lever-2').addClass('checked');
                }
                if (dataKey === 'f_textile_class') {
                    $(`.checkbox-lever-1[data-id="${dataId}"]`).parents('.category-group-lever-1').find('.category-group-lever-2').addClass('checked');
                }
                if (dataKey === 'f_formulation' && $('.input-on-off-percent').is(':checked')) {
                    dataName = dataName+' 100';
                    $(this).find(".refine-by-value-custom").html(dataName);
                }
                if (dataKey === 'f_formulation' && !$('.input-on-off-percent').is(':checked')){
                    $(this).find(".refine-by-value-custom").html(dataName);
                }
                $('.boost-pfs-filter-left-refine-by-custom .boost-pfs-filter-left-refine-by-items-custom').append(
                    `<div class="refine-by-item-left-custom boost-pfs-filter-option-label-custom" data-id="${dataId}" data-key="${dataKey}" data-value="${dataValue}" data-value-url="${dataValueUrl}" data-name="${dataName}" data-type="${dataType}">
                    <button class="boost-pfs-filter-button-custom boost-pfs-filter-clear-custom">
                    <span class="refine-by-type-custom">
                        <span class="refine-by-option-custom"></span><span class="refine-by-value-custom">${dataName}</span>
                    </span>
                    </button>
                </div>`
                );
            }
        });
        if ($(".boost-pfs-filter-left-refine-by-items-custom .refine-by-item-left-custom").length > 0) {
            $('.boost-pfs-filter-left-refine-by-wrapper-custom').show();
            $('.selected-item-filter-mobile').html($('.boost-pfs-filter-left-refine-by-wrapper-custom').parent().html());
        }
        if ($('.input-on-off-percent').is(':checked')) {
            $('.boost-pfs-filter-option-item-custom[data-key="f_formulation"][data-composition-absolute="0"]').addClass('no-percent-100');
        }
    }
}
function getItems(params) {
    let paramsSearch = {...params};
    if (typeof params['dye_method_name'] !== 'undefined') {
        const dye_method_name_attributes = {
            'Piece dyeing': 'Piece dyeing,Piece dyeing／Yarn dyeing,Piece dyeing／Yarn dyeing／Top dyed,Piece dyeing／Top dyed',
            'Yarn dyeing': 'Yarn dyeing,Piece dyeing／Yarn dyeing,Piece dyeing／Yarn dyeing／Top dyed,Yarn dyeing／Top dyed',
            'Top dyed': 'Top dyed,Piece dyeing／Yarn dyeing／Top dyed,Piece dyeing／Top dyed,Yarn dyeing／Top dyed'
        }
        const dye_method_name_search = params['dye_method_name'];
        let dye_method_name_search_array = dye_method_name_search.split(',');
        let dye_method_name_search_format_string = '';
        for (let i in dye_method_name_search_array) {
            if( i > 0 && i < dye_method_name_search_array.length ) {
                dye_method_name_search_format_string += ',';
              };
            if (typeof dye_method_name_attributes[dye_method_name_search_array[i]] !== 'undefined') {
                dye_method_name_search_format_string += dye_method_name_attributes[dye_method_name_search_array[i]];
            } else {
                dye_method_name_search_format_string += dye_method_name_search_array[i];
            }
        }
        let dye_method_name_search_format_array = dye_method_name_search_format_string.split(',');

        paramsSearch['dye_method_name'] = dye_method_name_search_format_array.filter((value, index, self) => {
            return self.indexOf(value) === index;
        }).join(',');
    }
    let responseData = false;
    $.ajax({
        url: "/apps/dev-1/filter_products",
        method: 'GET',
        dataType: 'json',
        data: paramsSearch,
        success: function (response) {
            if (response?.data) {
                responseData = {
                    productItems: response?.data,
                    pageInfo: {
                        currentPage: response?.page ? parseInt(response.page) : 1,
                        totalItem: response?.total?.value ? parseInt(response.total.value) : 0,
                    },
                    params: params,
                }
            }
        }
    });

    return responseData;
}

function renderPages(pageInfo) {
    let totalPage = Math.ceil(pageInfo.totalItem / PER_PAGE);
    $('.boost-pfs-filter-bottom-pagination-custom .Pagination').empty();
    if (totalPage > 1 && pageInfo.currentPage <= totalPage) {
        let paginationPrevious = '';
        let paginationNext = '';
        let paginationPreviousDot = '';
        let paginationNextDot = '';
        let firstPage = `<a class="Pagination__NavItem Link Link--primary" href="#" data-page="1">1</a>`;
        let lastPage = `<a class="Pagination__NavItem Link Link--primary" href="#" data-page="${totalPage}">${totalPage}</a>`;
        let paginationMainActive = '';
        let paginationMain = ``;

        if (pageInfo.currentPage > 1) {
            paginationPrevious =
            `<a class="Pagination__NavItem Link Link--primary" rel="prev" href="#" title="前へ"  data-page="${pageInfo.currentPage - 1}">
                <svg class="Icon Icon--select-arrow-left " role="presentation" viewBox="0 0 11 18">
                <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                </svg>
            </a>`;
        }
        if (pageInfo.currentPage < totalPage) {
            paginationNext =
            `<a class="Pagination__NavItem Link Link--primary" rel="next" href="#" title="次へ" data-page="${pageInfo.currentPage + 1}">
            <svg class="Icon Icon--select-arrow-right " role="presentation" viewBox="0 0 11 18">
                <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
            </svg>
            </a>`;
        }

        if (pageInfo.currentPage > 3 && totalPage > 5) {
            paginationPreviousDot = `<span class="Pagination__NavItem">...</span>`;
        }
        if (pageInfo.currentPage == 1 && totalPage > 5) {
            paginationMainActive =
            `<a class="Pagination__NavItem is-active" href="#" data-page="1">1</a>
            <a class="Pagination__NavItem Link Link--primary" href="#" data-page="2">2</a>`;
        }
        if (pageInfo.currentPage < totalPage - 2  && totalPage > 5) {
            paginationNextDot = `<span class="Pagination__NavItem">...</span>`;
        }
        if (pageInfo.currentPage == totalPage && totalPage > 5) {
            paginationMainActive =
            `<a class="Pagination__NavItem Link Link--primary" href="#" data-page="${totalPage - 1}">${totalPage -1}</a>
            <a class="Pagination__NavItem is-active" href="#" data-page="${totalPage}">${totalPage}</a>`;
        }
        if (pageInfo.currentPage > 1 && pageInfo.currentPage < totalPage && totalPage > 5) {
            paginationMainActive =
            `<a class="Pagination__NavItem Link Link--primary" href="#" data-page="${pageInfo.currentPage - 1}">${pageInfo.currentPage - 1}</a>
            <span class="Pagination__NavItem is-active">${pageInfo.currentPage}</span>
            <a class="Pagination__NavItem Link Link--primary" href="#" data-page="${pageInfo.currentPage + 1}">${pageInfo.currentPage + 1}</a>`;
        }
        if (pageInfo.currentPage < 3) {
            firstPage = '';
        }
        if (pageInfo.currentPage > totalPage - 2) {
            lastPage = '';
        }
        if (totalPage <= 5) {
            for(let i = 1; i <= totalPage; i++) {
                if(i == pageInfo.currentPage) {
                    paginationMain = paginationMain + `<a class="Pagination__NavItem is-active" href="#" data-page="${i}">${i}</a>`;
                } else {
                    paginationMain = paginationMain + `<a class="Pagination__NavItem Link Link--primary" href="#" data-page="${i}">${i}</a>`;
                }
            }
        } else if (totalPage > 5) {
            paginationMain = firstPage + paginationPreviousDot + paginationMainActive + paginationNextDot + lastPage;
        }
        $('.boost-pfs-filter-bottom-pagination-custom .Pagination').append(`
            <div class="Pagination__Nav">
            ${paginationPrevious}
            ${paginationMain}
            ${paginationNext}
            </div>
        `);
    }
}

// Change page
$(document).on('click','.Pagination__NavItem', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!$(this).hasClass('is-active')) {
        openFilterLoading();
        let page = $(this).attr('data-page');
        let data = {
            'action' : filterAction.changeToDefault,
            'page' : page,
        };

        // call API
        let searchStatus = searchFilterFunction(data);
        setTimeout(function () {
            cancelFilterLoading();
            scrollToElementById('collection-filter', 0);
        }, 0);
    }
});

function getSortParams() {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let entries = urlParams.entries();
    let sortData = {};
    for (const entry of entries) {
        if (entry[0] == 'sort_field' || entry[0] == 'sort_type') {
            sortData[entry[0]] = entry[1];
        }
    }
    if (Object.keys(sortData).length < 2) {
        let defaultSortOption = sortList.find(item => item.default && (item.default_page == displayPage.all || item.default_page == thisPage));
        sortData.sort_field = defaultSortOption?.sort_field;
        sortData.sort_type = defaultSortOption?.sort_type;
    }

    return sortData
}
// Show or hide clear all button
function showOrHideClearButton() {
    let count = 1;
    if ($('.boost-pfs-filter-refine-by-items-custom [data-key="product_stock"]').length > 0){
        $('.boost-pfs-filter-refine-by-items-custom [data-key="product_stock"]').hide();
        count ++;
    }
    let isShowOverlay = false;
    if ($('.boost-pfs-filter-refine-by-items-custom').children().length > count) {
        $('.boost-pfs-filter-clear-all-custom').show();
        $('.boost-pfs-filter-refine-by-wrapper-custom').show();
        $('.boost-pfs-filter-left-refine-by-wrapper-custom').show();
        isShowOverlay = true;
    } else {
        $('.boost-pfs-filter-refine-by-wrapper-custom').hide();
        $('.boost-pfs-filter-clear-all-custom').hide();
        $('.boost-pfs-filter-left-refine-by-wrapper-custom').hide();
        isShowOverlay = false;
    }
    appendSearchLeftFilter();
    const filterRefineChangeEvent = new CustomEvent('filterRefineChange', { detail: isShowOverlay });
    document.dispatchEvent(filterRefineChangeEvent);
}

// Change rangbar value by input
$(document).on('change','.range-input-value', function (e) {
    e.preventDefault();
    e.stopPropagation();
    let sliderElement = $(this).parents('.range-bar').find('.slider-range-class');
    let sliderValues = sliderElement.slider('values');
    let sliderDefaultValues = $(this).parents('.range-bar').attr('data-value-default');
    sliderDefaultValues = sliderDefaultValues.split('-').map(function(item) {
        return parseInt(item);
    });
    let value = Math.round($(this).val());
    let ui = {
        values: sliderValues
    };
    if ($(this).hasClass('boost-pfs-filter-option-range-amount-min-custom')) {
        if (isNaN(value)) {
            $(this).val(sliderValues[0]);
            return;
        } else {
            value = value < sliderDefaultValues[0] ? sliderDefaultValues[0]
                : (value > sliderValues[1] ? sliderValues[1] : value);
            $(this).val(value);
            $(this).parents('.range-bar').find('.slider-range-class').slider('values', 0, value);
            ui.values[0] = value;
        }
    } else if ($(this).hasClass('boost-pfs-filter-option-range-amount-max-custom')) {
        if (isNaN(value)) {
            $(this).val(sliderValues[1]);
            return;
        } else {
            value = value > sliderDefaultValues[1] ? sliderDefaultValues[1]
                : (value < sliderValues[0] ? sliderValues[0] : value);
            $(this).val(value);
            $(this).parents('.range-bar').find('.slider-range-class').slider('values', 1, value);
            ui.values[1] = value;
        }
    }
    let slider = $(this).parents('.range-bar').find('.slider-range-class');
    slider.slider('option', 'stop').call(slider, e, ui);
});


// Sort function
$(document).on('click','.Popover__Content .Popover__ValueList [data-action="select-value-custom"]', function (e) {
    if (!$(this).hasClass('is-selected')) {
        const sortText = $(this).text().trim();
        $('.CollectionToolbar__Item.btn-open-sort span').text(sortText);
        openFilterLoading();
        let sortField = $(this).attr('data-sort-field');
        let sortValue = $(this).attr('data-sort-value');
        let data = {
            'action': filterAction.changeToDefault,
            'sort_field': sortField,
            'sort_type': sortValue
        };

        // call API
        let searchStatus = searchFilterFunction(data);
        if (searchStatus) {
            $('.Popover__Content .Popover__ValueList .is-selected[data-action="select-value-custom"]').removeClass('is-selected');
            $(this).addClass('is-selected');
        }
        setTimeout(function () {
            cancelFilterLoading();
        }, 0);
    }
});

function searchHandle(e) {
    e.preventDefault();
    if (e.keyCode === 13) {
        return;
    }

    const searchBoxSidebarName = 'search_box_sidebar';
    let inputName = e.target.name;
    lastInputValue = e.target.value;
    $(e.target).val(lastInputValue);

    if (inputName == searchBoxSidebarName) {
        $('.boost-pfs-filter-left-col-custom .stm-instant-search').removeClass('stm-instant-search-for-product');
    } else {
        $('.boost-pfs-filter-left-col-custom .stm-instant-search').addClass('stm-instant-search-for-product');
    }

    if (lastInputValue === '') {
        $(e.target).parents('.boost-pfs-filter-left-col-custom').find('.stm-instant-search-wrap').empty();
        $(e.target).parents('.boost-pfs-filter-left-col-custom').find('.stm-instant-search').each(function(index) {
            this.setAttribute('aria-hidden', 'true');
        });
        $('.stm-instant-search-wrap').empty();
        return;
    }
    var queryOptions = {
        method: 'GET',
        credentials: 'same-origin'
    };
    let isLogin = !!window.customerId;
    let inputValue = e.target.value;
    var queries = [];
    let searchText = $('#get-language-translation').attr("data-text-search");
    let merchandiseText = $('#get-language-translation').attr("data-text-merchandise");
    let noResultText = $('#get-language-translation').attr("data-text-no-result-1");
    let noResultNote = $('#get-language-translation').attr("data-text-no-result-2");

    if (inputName == searchBoxSidebarName) {
        queries.push(fetch("/apps/dev-1/filter_products/page-blogs?search_box_sidebar=" + encodeURIComponent(inputValue), queryOptions));
        queries.push(fetch("/apps/dev-1/filter_products?is_login=".concat(isLogin, "&search_box_sidebar=", encodeURIComponent(inputValue), "&page=1&per_page=6"), queryOptions));
    } else {
        queries.push(fetch("/apps/dev-1/filter_products/page-blogs?search_box=" + encodeURIComponent(inputValue), queryOptions));
        queries.push(fetch("/apps/dev-1/filter_products?is_login=".concat(isLogin, "&product_id=", encodeURIComponent(inputValue), "&page=1&per_page=6"), queryOptions));
    }

    $('.boost-pfs-filter-left-col-custom .stm-instant-search-wrap').empty();
        let htmlLoading =
            '<div class="boost-pfs-search-suggestion-loading">' +
                '<ul>' +
                    '<li>' +
                        '<div class="boost-pfs-search-suggestion-loading-img"></div>' +
                    '</li>' +
                    '<li>' +
                        '<div class="boost-pfs-search-suggestion-loading-img"></div>' +
                    '</li>' +
                    '<li>' +
                        '<div class="boost-pfs-search-suggestion-loading-img"></div>' +
                    '</li>' +
                '</ul>' +
            '</div>';
        $('.boost-pfs-filter-left-col-custom .stm-instant-search-wrap').append(htmlLoading);
        $('.boost-pfs-filter-left-col-custom .stm-instant-search').each(function (item) {
            this.setAttribute('aria-hidden', 'false')
        });
        Promise.all(queries).then(function (responses) {
            Promise.all(responses.map(function (response) {
                return response.text();
            })).then(function (contents) {
            $('.boost-pfs-filter-left-col-custom .stm-instant-search-wrap').html('');
            let searchOthersData = JSON.parse(contents[0]);
            let searchProductsData = JSON.parse(contents[1]);

            let htmlSearchResults = '';
            let htmlResultOthers = '';
            let htmlResultProducts = '';

            if (inputName == searchBoxSidebarName) {
                htmlResultOthers += createCollectionContent(inputValue, searchOthersData);
                htmlResultOthers += createBlogContent(inputValue, searchOthersData);
                htmlResultOthers += createPageContent(inputValue, searchOthersData);

                if (htmlResultOthers !== '') {
                    htmlResultOthers = '<div class="stm-instant-search-group-others">' + htmlResultOthers + '</div>';
                }
            }

            if (searchProductsData?.data?.length > 0) {
                let htmlProductContent = '';
                searchProductsData.data.map((item) => {
                    let itemImg = '';
                    if (item.shopify_content?.image?.src) {
                        itemImg = '<img src="' + item.shopify_content.image.src + '" alt="product image">';
                    } else {
                        itemImg = '<span class="stm-instant-search-product-no-img"></span>';
                    }

                    htmlProductContent +=
                        '<li>' +
                            '<a href="/products/' + item.product_id + '">' +
                                '<div class="stm-instant-search-product-img">' + itemImg + '</div>' +
                                '<div class="stm-instant-search-product-info">' +
                                    `${
                                        item?.product_label ? `
                                          <label class="product-label product-label-filter">
                                              ${generateProductLabel(item?.product_label)}
                                          </label>
                                        ` : ''
                                    }` +
                                    '<b>' + item.product_id + '</b>' +
                                '</div>' +
                            '</a>' +
                        '</li>';
                })

                if (searchProductsData.total.value > 6) {
                    htmlResultProducts =
                        '<div class="stm-instant-search-group-products">' +
                            '<div class="stm-instant-search-group">' +
                                `<p>${merchandiseText}</p>` +
                                '<div class="stm-instant-search-product-all">' +
                                    `<a href="/search?${inputName == searchBoxSidebarName ? 'search_box_sidebar' : 'product_id'}=` + inputValue + `"><span>${searchText}</span></a>` +
                                '</div>' +
                                '<ul>' + htmlProductContent + '</ul>' +
                            '</div>' +
                        '</div>';
                } else {
                    htmlResultProducts =
                    '<div class="stm-instant-search-group-products">' +
                        '<div class="stm-instant-search-group">' +
                            `<p>${merchandiseText}</p>` +
                            '<ul>' + htmlProductContent + '</ul>' +
                        '</div>' +
                    '</div>';
                }
            } else {
                if (inputName == searchBoxSidebarName) {
                    htmlResultProducts =
                      '<div class="stm-instant-search-group-products">' +
                            '<span class="stm-instant-search-no-product">' + noResultText + '"<strong>' + inputValue?.replaceAll('<','&#60;').replaceAll('>','&#62;') + '</strong>"' + '<br />' + noResultNote + '</span>' +
                      '</div>';
                } else {
                    htmlResultProducts =
                      '<div class="stm-instant-search-group-products">' +
                          '<div class="stm-instant-search-group">' +
                                `<p>${merchandiseText}</p>` +
                              '<span class="stm-instant-search-no-product">' + noResultText + '"<strong>' + inputValue?.replaceAll('<','&#60;').replaceAll('>','&#62;') + '</strong>"' + '<br />' + noResultNote + '</span>' +
                          '</div>' +
                      '</div>';
                }
            }
            htmlSearchResults += htmlResultProducts + htmlResultOthers;
            $('.boost-pfs-filter-left-col-custom .stm-instant-search-wrap').empty();
            if(e.target.value !== '') {
                $('.boost-pfs-filter-left-col-custom .stm-instant-search-wrap').append(htmlSearchResults);
                $('.boost-pfs-filter-left-col-custom .stm-instant-search').each(function (item) {
                    this.setAttribute('aria-hidden', 'false')
                });
            }
        });
    });
}

function clearAndHideSearchBarData() {
    $('.boost-pfs-filter-left-col-custom .stm-instant-search.stm-instant-search-for-all').each(function (item) {
        this.setAttribute('aria-hidden', 'true')
    });
    $('.boost-pfs-filter-left-col-custom .stm-instant-search.stm-instant-search-for-product').each(function (item) {
        this.setAttribute('aria-hidden', 'true')
    });
}

function createBlogContent(inputValue, searchOthersData) {
    let htmlBlogContent = '';
    let searchBlogData = searchOthersData?.blog_posts;

    if (!searchBlogData || !searchBlogData?.data?.length) {
        return htmlBlogContent;
    }

    let inputValueArray = inputValue.split(' ').filter(item => item.length > 1);
    inputValueArray = inputValueArray.map(item => item.split("").map(subItem => `[${subItem}]`).join(""));
    searchBlogData.data.slice(0, 6).map((item) => {
        let itemTitle = item.title;
        itemTitle = itemTitle?.replaceAll('<!--','').replaceAll('-->','').replaceAll('<','&#60;').replaceAll('>','&#62;');
        if(inputValueArray.length > 0) {
            itemTitle = itemTitle.replace(new RegExp('(' + inputValueArray.join('|')?.replaceAll('<','&#60;').replaceAll('>','&#62;') + ')','ig'), `<b>$1</b>`);
        }
        htmlBlogContent += '<li><a href="' + item.handle + '">' + itemTitle + '</a></li>';
    });
    let blogText = $('#get-language-translation').attr("data-text-blog");

    if (htmlBlogContent !== '') {
        htmlBlogContent =
          '<div class="stm-instant-search-group">' +
          `<p>${blogText}</p>` +
          '<ul>' + htmlBlogContent + '</ul>' +
          '</div>';
    }

    return htmlBlogContent;
}

function createPageContent(inputValue, searchOthersData) {
    let htmlPageContent = '';
    let searchPageData = searchOthersData?.pages;

    if (!searchPageData || !searchPageData?.data?.length) {
        return htmlPageContent;
    }

    let inputValueArray = inputValue.split(' ').filter(item => item.length > 1);
    inputValueArray = inputValueArray.map(item => item.split("").map(subItem => `[${subItem}]`).join(""));
    searchPageData.data.slice(0, 6).map((item) => {
        let itemTitle = item.title;
        itemTitle = itemTitle?.replaceAll('<!--','').replaceAll('-->','').replaceAll('<','&#60;').replaceAll('>','&#62;');
        if(inputValueArray.length > 0) {
            itemTitle = itemTitle.replace(new RegExp('(' + inputValueArray.join('|')?.replaceAll('<','&#60;').replaceAll('>','&#62;') + ')','ig'), `<b>$1</b>`);
        }
        htmlPageContent += '<li><a href="' + item.handle + '">' + itemTitle + '</a></li>';
    });
    let pageText = $('#get-language-translation').attr("data-text-page");

    if (htmlPageContent !== '') {
        htmlPageContent =
          '<div class="stm-instant-search-group">' +
          `<p>${pageText}</p>` +
          '<ul>' + htmlPageContent + '</ul>' +
          '</div>';
    }

    return htmlPageContent;
}

function createCollectionContent(inputValue, searchOthersData) {
    let htmlCollectionContent = '';
    let searchCollectionData = searchOthersData?.collections;

    if (!searchCollectionData || !searchCollectionData?.data?.length) {
        return htmlCollectionContent;
    }

    let inputValueArray = inputValue.split(' ').filter(item => item.length > 1);
    inputValueArray = inputValueArray.map(item => item.split("").map(subItem => `[${subItem}]`).join(""));
    searchCollectionData.data.slice(0, 6).map((item) => {
        let itemTitle = item.title;
        itemTitle = itemTitle?.replaceAll('<!--','').replaceAll('-->','').replaceAll('<','&#60;').replaceAll('>','&#62;');
        if(inputValueArray.length > 0) {
            itemTitle = itemTitle.replace(new RegExp('(' + inputValueArray.join('|')?.replaceAll('<','&#60;').replaceAll('>','&#62;') + ')','ig'), `<b>$1</b>`);
        }
        htmlCollectionContent += '<li><a href="' + item.handle + '">' + itemTitle + '</a></li>';
    });
    let collectionText = $('#get-language-translation').attr("data-text-collection");

    if (htmlCollectionContent !== '') {
        htmlCollectionContent =
          '<div class="stm-instant-search-group">' +
          `<p>${ collectionText }</p>` +
          '<ul>' + htmlCollectionContent + '</ul>' +
          '</div>';
    }

    return htmlCollectionContent;
}

$(document).on('click', '.boost-pfs-filter-left-col-custom .boost-pfs-filter-option-title-custom', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (!$('.template-collection .boost-pfs-filter-left-col-custom').hasClass('open-filter')) {
        $('.CollectionMain').addClass('has-filter');
        $('.template-collection .boost-pfs-filter-left-col-custom').addClass('open-filter');
    }
});

const debounce = (func, delay) => {
    let debounceTimer
    return function() {
        const context = this
        const args = arguments
            clearTimeout(debounceTimer)
                debounceTimer
            = setTimeout(() => func.apply(context, args), delay)
    }
}

// input search on filter sidebar, now not use, after dev ticket 2578
$(document).on('input click', '.boost-pfs-filter-left-col-custom .Search__Input', debounce( function(e) {
    searchHandle(e)
}, 250));

$(document).ready(function() {
    $('.boost-pfs-filter-left-col-custom .Search__Input').keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
    let path = window.location.pathname;
    let pathParts = path.split('/');
    let collectionSlug = pathParts[pathParts.length - 1];
    if (collectionSlug == 'stock-available' || collectionSlug == 'digital-fabric-available') {
        $(`.filter-top-to-collection`).removeClass('is-selected');
        $(`.filter-top-to-collection[data-collection="${collectionSlug}"]`).addClass('is-selected');
        $('.show-colection-selected').html($(`.filter-top-to-collection[data-collection="${collectionSlug}"]`).text());
    } else {
        $(`.filter-top-to-collection`).removeClass('is-selected');
        $(`.filter-top-to-collection[data-collection="stock-available"]`).addClass('is-selected');
        $('.show-colection-selected').html($(`.filter-top-to-collection[data-collection="stock-available"]`).text());
    }
});

$(document).click(function(event) {
    let $target = $(event.target);
    if (
        !$target.closest('.boost-pfs-filter-left-col-custom .stm-instant-search').length
        && $('.boost-pfs-filter-left-col-custom .stm-instant-search').attr("aria-hidden") == "false"
        && !$target.closest('.boost-pfs-filter-left-col-custom .Search__Input').length
    ) {
        $('.boost-pfs-filter-left-col-custom .stm-instant-search').attr("aria-hidden", "true");
    }
});

$(document).on('click', '.filter-top-to-collection', function(e) {
    const collectionHandle = $(this).attr('data-collection');
    const searchParams = new URLSearchParams(window.location.search);
    const isExistPageParam = searchParams.has('page');
    if (isExistPageParam) {
        searchParams.delete('page');
    }
    const paramNumber = searchParams.size;
    const queryString = `${paramNumber > 0 ? '?' : ''}${searchParams.toString()}`;
    window.location.href = `/collections/${collectionHandle}${queryString}`;
});

$(document).on('click','body.template-collection .clear-search-header, body.template-search .clear-search-header', function (e) {
  e.preventDefault();
  e.stopPropagation();
  clearSearchHeader();
});

// toggle category-name for each category__wrap
$(document).on('click','#collection-filter .boost-pfs-filter-option-content-custom .category__wrap .category-name:not(.hidden)', function (e) {
  e.preventDefault();
  $(this).parents('.category__wrap').toggleClass('toggled');
});

$(document).on('click', '.select-arrow', function (e) {
    e.preventDefault();
    // if (!checkNoCustomer()) {
    // }
    $(this).next().removeClass("hidden");
    $(this).addClass('hidden');
    $(this).parents('.category-group-lever-1').find('.category-group-lever-2').removeClass('hidden');
});

$(document).on('click', '.select-top', function (e) {
    e.preventDefault();
    // if (!checkNoCustomer()) {
        $(this).parents('.category-group-lever-1').find('.category-group-lever-2').addClass('hidden');
        $(this).prev().removeClass("hidden");
        $(this).addClass('hidden');
    // }
});

$(document).on('click', '.select-arrow-lever-3', function (e) {
    e.preventDefault();
    // if (!checkNoCustomer()) {
    // }
    $(this).next().removeClass("hidden");
    $(this).addClass('hidden');
    $(this).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-list-custom').removeClass('hidden');
});

$(document).on('click', '.select-top-lever-3', function (e) {
    e.preventDefault();
    // if (!checkNoCustomer()) {
        $(this).prev().removeClass("hidden");
        $(this).addClass('hidden');
        $(this).parents('.category-group-lever-2').find('.boost-pfs-filter-option-item-list-custom').addClass('hidden');
    // }
});
$(document).on('click', '.input-on-off-percent', function (e) {
    // if (!checkNoCustomer()) {
        openFilterLoading();
        let thisAction = $(this).is(':checked')
            ? filterAction.add : filterAction.delete;
        let data = {
            'action': thisAction,
            'id': 'is_composition_absolute',
            'type': 'is_composition_absolute',
            'key': 'is_composition_absolute',
            'value': $(this).is(':checked'),
            'valueUrl': $(this).is(':checked')
        };
        if ($(this).is(':checked')) {
            $('.boost-pfs-filter-left-on-off-percent').addClass('checked');
        } else {
            $('.boost-pfs-filter-left-on-off-percent').removeClass('checked');
        }
        let searchStatus = searchFilterFunction(data);
        showOrHideClearButton();
        setTimeout(function () {
            cancelFilterLoading();
        }, 200);
    // }
});

$(document).on('click', '.btn-check-sqm', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).hasClass('checked')){
        let sliderElement = $(this).parents('.range-bar').find('.slider-range-class');
        let sliderValues = sliderElement.slider('values');
        let sliderDefaultValues = $(this).parents('.range-bar').attr('data-value-default');
        sliderDefaultValues = sliderDefaultValues.split('-').map(function(item) {
            return parseInt(item);
        });
        let ui = {
            values: sliderValues
        };
        $(this).parents('.range-bar').find('.slider-range-class').slider('values', 0, sliderDefaultValues[0]);
        $(this).parents('.range-bar').find('.boost-pfs-filter-option-range-amount-min-custom').val(sliderDefaultValues[0]);
        ui.values[0] = sliderDefaultValues[0];
        $(this).parents('.range-bar').find('.slider-range-class').slider('values', 1, sliderDefaultValues[1]);
        $(this).parents('.range-bar').find('.boost-pfs-filter-option-range-amount-max-custom').val(sliderDefaultValues[1]);
        ui.values[1] = sliderDefaultValues[1];
        let slider = $(this).parents('.range-bar').find('.slider-range-class');
        slider.slider('option', 'stop').call(slider, e, ui);
        $(this).removeClass('checked');
    } else {
        $('.btn-check-sqm').removeClass('checked');
        let sliderElement = $(this).parents('.range-bar').find('.slider-range-class');
        let sliderValues = sliderElement.slider('values');
        const dataValueRange = $(this).attr('data-value');
        let valuesRange = dataValueRange.split('-').map(function(item) {
            return parseInt(item);
        });
        let ui = {
            values: sliderValues
        };
        $(this).parents('.range-bar').find('.slider-range-class').slider('values', 0, valuesRange[0]);
        $(this).parents('.range-bar').find('.boost-pfs-filter-option-range-amount-min-custom').val(valuesRange[0]);
        ui.values[0] = valuesRange[0];
        $(this).parents('.range-bar').find('.slider-range-class').slider('values', 1, valuesRange[1]);
        $(this).parents('.range-bar').find('.boost-pfs-filter-option-range-amount-max-custom').val(valuesRange[1]);
        ui.values[1] = valuesRange[1];
        let slider = $(this).parents('.range-bar').find('.slider-range-class');
        slider.slider('option', 'stop').call(slider, e, ui);
        $(this).addClass('checked');
    }
});
